// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:11:34.294Z
// Property: Park 220 (ID: 6767906449166978)
// Collections: 15 amenities, 4 floorplans (live), 33 photos, 71 POIs, 4 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449166978",
  "property_external_id": "5599111",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/park-220-elk-city-ok/87516b0/",
  "property_google_business_url": "https://www.google.com/maps/place/Park+220/data=!4m2!3m1!1s0x0:0x1f65dd5a68dee629?sa=X&ved=2ahUKEwiGiuLC0rySAxVDLTQIHTd7I5MQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "45778902284",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-220",
  "property_name": "Park 220",
  "property_website_url": "https://www.park220apts.com/",
  "property_domain": "https://www.park220apts.com/",
  "property_address": "220 Ridgecrest Dr",
  "property_full_address": "220 Ridgecrest Dr, Elk City, OK 73644",
  "property_address_1": "220 Ridgecrest Dr",
  "property_address_2": null,
  "property_address_city": "Elk City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73644",
  "property_address_country": "US",
  "property_address_county": "Beckham County",
  "property_neighborhood_address": "Oklahoma West Area",
  "property_address_latitude": "35.3850352",
  "property_address_longitude": "-99.39679760000001",
  "property_email": "Park220@rrliving.com",
  "property_phone": "(580) 563-0525",
  "property_call_tracking_phone": "580-313-7381",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Park 220 in Elk City, OK, experience a lifestyle tailored to you. Choose from stylish studio to spacious three-bedroom floor plans, all featuring modern finishes and energy-efficient amenities. Enjoy perks like covered parking, a newly remodeled laundry room, and seasonal pool access. Connect with us and find your new home today!",
  "property_long_description": "**Discover Your Dream Home at Park 220 in Elk City, OK**\n\nWelcome to Park 220, where modern living meets exceptional comfort. Our beautifully designed apartment community offers a range of thoughtfully crafted floor plans, including cozy studios, spacious one, two, and three-bedroom apartments, perfect for every lifestyle. Each unit showcases designer-selected modern finishes, featuring energy-efficient appliances, wood-style flooring, and inviting 9-foot ceilings that create an airy ambiance.\n\nAt Park 220, we prioritize your convenience and satisfaction. Enjoy covered parking at no extra charge, and take advantage of our newly remodeled laundry room with 24/7 access. Dive into refreshing leisure at our seasonal pool or gather with friends in the welcoming clubhouse. Our on-site maintenance team and property manager are dedicated to ensuring a hassle-free living experience. \n\nLive smoke-free in a community designed for comfort and connectivity, offering high-speed internet and cable readiness, along with optional washer/dryer hookups in select units. Experience ultimate relaxation with amenities like air conditioning, heating, and select units featuring a cozy fireplace or a breakfast bar for added convenience.\n\nFor those in need of extra space, we offer storage units available for your belongings. \n\nChoose Park 220 as your next home in Elk City, OK, and immerse yourself in a vibrant community that caters to your needs. Don’t wait—find your new home today! Browse our availability or schedule a tour to experience Park 220's unmatched lifestyle firsthand.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-e779-75bb-a648-407d3b3e686e.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool area with lounge chairs and buildings in the background.",
    "public_id": "019fb451-e779-75bb-a648-407d3b3e686e",
    "storage_key": "property/6767906449166978/019fb451-e779-75bb-a648-407d3b3e686e.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "159",
  "property_year_built": "1978",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "75.47169811320755",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We welcome cats and dogs.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://park220.loftliving.com/login",
  "property_apply_now_url": "https://9273740.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019e699d-512d-71f6-9c93-235dde304b76.webp",
  "property_primary_logo_media": {
    "alt_text": "Park 220 Apartments logo.",
    "public_id": "019e699d-512d-71f6-9c93-235dde304b76",
    "storage_key": "property/6767906449166978/019e699d-512d-71f6-9c93-235dde304b76.webp",
    "width": 3072,
    "height": 1075
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019e699e-154a-726a-b34d-3812fc079f43.webp",
  "property_secondary_logo_media": {
    "alt_text": "Park 220 Apartments logo",
    "public_id": "019e699e-154a-726a-b34d-3812fc079f43",
    "storage_key": "property/6767906449166978/019e699e-154a-726a-b34d-3812fc079f43.webp",
    "width": 3072,
    "height": 1075
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019e699e-10fd-77aa-9ee6-1778cdc68d3b.webp",
  "property_icon_media": {
    "alt_text": "Park 220 logo with text 'PARK 220 ELK CITY, OK'",
    "public_id": "019e699e-10fd-77aa-9ee6-1778cdc68d3b",
    "storage_key": "property/6767906449166978/019e699e-10fd-77aa-9ee6-1778cdc68d3b.webp",
    "width": 2250,
    "height": 2250
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019e699e-10f9-74ef-a75d-d7c430b20a87.webp",
  "property_fav_icon_media": {
    "alt_text": "Park 220 logo",
    "public_id": "019e699e-10f9-74ef-a75d-d7c430b20a87",
    "storage_key": "property/6767906449166978/019e699e-10f9-74ef-a75d-d7c430b20a87.webp",
    "width": 2250,
    "height": 2250
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-5d78-71fd-86f8-9005708caca0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Park 220 Apartments logo",
    "public_id": "019fb452-5d78-71fd-86f8-9005708caca0",
    "storage_key": "property/6767906449166978/019fb452-5d78-71fd-86f8-9005708caca0.webp",
    "width": 640,
    "height": 224
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-d1ca-75aa-9da3-387c9b954d7c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Park 220 Apartments logo",
    "public_id": "019fb451-d1ca-75aa-9da3-387c9b954d7c",
    "storage_key": "property/6767906449166978/019fb451-d1ca-75aa-9da3-387c9b954d7c.webp",
    "width": 640,
    "height": 224
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#002c43",
  "property_secondary_color": "#d5cbba",
  "property_font_color": "#000000",
  "property_color_4": "#f8f9f9",
  "property_color_3": "#2469b7",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "325 - 1490",
  "property_sqft_min": "325",
  "property_sqft_max": "1490",
  "property_price_range": "450 - 900",
  "property_price_min": "450",
  "property_price_max": "900",
  "property_available_units": 39,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61568060838005",
  "property_instagram_url": "https://www.instagram.com/park220_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJX37OBT3lq4cRKebeaFrdZR8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cimarron-ridge-apartments-elk-city",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park 220",
  "property_home_romance_title": "Find Your Forever Home in Our Charming Community",
  "property_home_amenities_blurb": "<p>Convenient to Interstate and our main office. Family friendly floor plan that includes an eat-in kitchen in our two bedroom units. Covered parking is included at no extra charge. The laundry room is newly remodeled and open 24/7. Seasonal pool access is also available.</p>",
  "property_home_floorplans_blurb": "<p>At Park 220 in Elk City, OK, a world of comfort awaits with our diverse floor plans. Choose from cozy studios to spacious two-bedroom homes, each designed to elevate your living experience. Browse our available options and find the floor plan that perfectly fits your lifestyle today!</p>",
  "property_home_gallery_blurb": "<p>At Park 220 in Elk City, OK, every moment is an experience. Imagine modern living in stylish studio, one, or two-bedroom apartments featuring high ceilings, designer finishes, and seasonal pool access. Enjoy covered parking, a newly remodeled laundry room, and a vibrant clubhouse. Picture yourself living here!</p>",
  "property_home_neighborhood_blurb": "Welcome to Park 220, where comfort meets community in Elk City, OK. Choose from our diverse floor plans—studio to three-bedroom—perfect for every lifestyle. Nestled near vibrant parks, schools, and cultural sites, you'll enjoy easy access to the National Route 66 Museum and outdoor adventures. Embrace your new home today!",
  "property_home_reviews_blurb": "At Park 220 in Elk City, OK, residents relish their spacious apartments and attentive service. One happy couple notes, \"If something does ever happen... they are quick to fix the concern.\" Experience community living where kindness and professionalism create a welcome home. See what our residents have to say!",
  "property_neighborhood_blurb": "<p>Welcome to Park 220, where comfort meets community in Elk City, OK. Choose from our diverse floor plans—studio to two-bedroom—perfect for every lifestyle. Nestled near vibrant parks, schools, and cultural sites, you'll enjoy easy access to the National Route 66 Museum and outdoor adventures. Embrace your new home today!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Welcome to Park 220 in Elk City, where modern living meets comfort! Enjoy spacious floor plans from studios to two-bedroom apartments, complemented by top-notch amenities such as a newly remodeled laundry room, a sparkling seasonal pool, and on-site maintenance. Experience a smoke-free lifestyle enhanced by designer finishes and energy-efficient features!</p>",
  "property_applynow_blurb": "At Park 220 in Elk City, OK, your ideal living space awaits—choose from stylish studios to spacious three-bedroom floor plans. Enjoy exclusive amenities like covered parking, a newly remodeled laundry room, and seasonal pool access. Ready to elevate your lifestyle? Secure your new home and lease online today!",
  "property_contactus_blurb": "At Park 220 in Elk City, OK, our diverse floor plans—ranging from cozy studios to spacious three-bedrooms—are designed to elevate your living experience. Whether you seek comfort or style, we have the perfect apartment waiting for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Park 220 in Elk City, OK, we cater to every lifestyle with our diverse floor plans, from cozy studios to spacious three-bedroom apartments. Curious about your future home? Visit our FAQs page for insights and answers about our vibrant community and all it has to offer!",
  "property_floorplans_blurb": "<p>At Park 220 in Elk City, OK, a world of comfort awaits with our diverse floor plans. Choose from cozy studios to spacious two-bedroom homes, each designed to elevate your living experience. Browse our available options and find the floor plan that perfectly fits your lifestyle today!</p>",
  "property_gallery_blurb": "<p>At Park 220 in Elk City, OK, every moment is an experience. Imagine modern living in stylish studio, one, or two-bedroom apartments featuring high ceilings, designer finishes, and seasonal pool access. Enjoy covered parking, a newly remodeled laundry room, and a vibrant clubhouse. Picture yourself living here!</p>",
  "property_interactivemap_blurb": "At Park 220 in Elk City, OK, find your ideal living space with our diverse floor plans, including studios, one, two, and three-bedroom options. Enjoy modern amenities like a newly remodeled laundry room, smoke-free environment, and seasonal pool access. Use our interactive community map to explore available apartments and pricing!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Park 220 in Elk City, OK, vibrant living awaits you! Whether you’re seeking a cozy studio or a spacious three-bedroom, each floor plan offers comfort and style. Great friends make great neighbors—refer a friend today and share in the joy of our welcoming community!",
  "property_residentaccess_blurb": "Welcome to Park 220 in Elk City, OK, where comfort meets convenience. Our diverse floor plans—including cozy studios and spacious three-bedrooms—cater to every lifestyle. Need to access your resident portal? Log in now to pay rent, schedule maintenance, and enjoy seamless living at Park 220!",
  "property_reviews_blurb": "At Park 220 in Elk City, OK, residents praise our friendly staff and swift maintenance, making it a cherished community to call home. One resident notes, \"Our apartment is well kept and spacious,\" highlighting the quality of living here. Join a community that truly cares about your comfort! ",
  "property_created_at": "1767904672928",
  "property_scheduletour_blurb": "At Park 220 in Elk City, OK, your new home awaits across a variety of thoughtfully designed floor plans—studio, one, two, and three-bedroom options cater to every lifestyle. Schedule a tour today and hear firsthand what our residents love about calling this vibrant community home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Park 220 in Elk City, OK, we offer versatile floor plans, including studios, one, two, and three-bedroom apartments, designed with your lifestyle in mind. Our team looks forward to connecting with you soon to help find your perfect home!",
  "property_virtualtours_blurb": "At Park 220 in Elk City, OK, your perfect living space awaits! Choose from a variety of thoughtfully designed floor plans, including studio, one-bedroom, two-bedroom, and three-bedroom options. Immerse yourself in our vibrant community by taking a virtual tour of your future home today!",
  "property_copyright": "2026 All Rights Reserved. Park 220",
  "property_seo_title_home": "Park 220 |  Apartments in Elk City, OK",
  "property_seo_description_home": "Unwind at Park 220 in Elk City, OK—modern comfort, spacious floor plans, a pool, and great amenities await. Discover your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Elk City, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Park 220 in Elk City, OK! Choose from stylish studios to spacious three-bedroom layouts. Browse floor plans to elevate your lifestyle!",
  "property_seo_title_amenities": "Amenities | Elk City, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience effortless living at Park 220 in Elk City, OK! Enjoy modern amenities, spacious floor plans, and a smoke-free environment. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Elk City, OK",
  "property_seo_description_gallery": "Step into Park 220 in Elk City, OK—where modern comforts meet vibrant living. Enjoy upscale amenities and stunning designs. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Park 220 Apartments",
  "property_seo_description_virtualtours": "Step inside Park 220 in Elk City, OK! Experience our stylish studio to three-bedroom apartments with a virtual tour. Your ideal home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Park 220 Apartments",
  "property_seo_description_interactivemap": "Elevate your lifestyle at Park 220 in Elk City, OK! Find the perfect apartment on our interactive map and enjoy unmatched amenities and modern designs!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Elk City, OK",
  "property_seo_description_neighborhood": "Uncover Elk City's hidden gems around Park 220! From studios to spacious three-bedrooms, discover vibrant local favorites just steps from home.",
  "property_seo_title_contact": "Contact Us | Park 220",
  "property_seo_description_contact": "Discover comfort at Park 220, Elk City, OK. Choose from cozy studios to spacious three-bedrooms. Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Elk City, OK",
  "property_seo_description_faqs": "Find answers to your questions about Park 220 in Elk City. Learn about our spacious units, amenities, and community life—discover your perfect home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Elk City, OK",
  "property_seo_description_reviews": "At Park 220 in Elk City, residents love our modern amenities, spacious floor plans, and warm community vibe. Read their reviews and feel at home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Elk City, OK",
  "property_seo_description_applynow": "Elevate your lifestyle at Park 220 in Elk City! Enjoy modern finishes, a refreshing pool, 24/7 laundry, and smoke-free living. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Park 220",
  "property_seo_description_residentaccess": "Log in to Park 220's resident portal for easy rent payments, maintenance requests, and community updates. Stay connected in Elk City, OK!",
  "property_seo_title_referafriend": "Refer A Friend | Park 220",
  "property_seo_description_referafriend": "Elevate your living experience at Park 220 in Elk City! Refer a friend today and enjoy the perks of great neighbors and even better community vibes.",
  "property_seo_title_scheduletour": "Schedule a Tour | Park 220",
  "property_seo_description_scheduletour": "Experience the charm of Park 220 in Elk City, OK. Schedule a tour today and find your new home in a vibrant community with modern comforts and stylish living!",
  "property_seo_title_privacy": "Privacy Policy | Park 220",
  "property_seo_description_privacy": "Learn how Park 220 in Elk City prioritizes your privacy. Read our policy to see what measures we take to protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Park 220",
  "property_seo_description_accessibility": "Experience digital inclusion at Park 220 in Elk City, OK. Our commitment to accessibility ensures everyone enjoys a seamless online experience. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Park 220",
  "property_seo_description_sitemap": "Navigate your way through Park 220 in Elk City, OK. Check out our sitemap for a seamless journey to your new home and community amenities!",
  "property_seo_title_thankyou": "Thank You | Park 220",
  "property_seo_description_thankyou": "Thank you for reaching out! We appreciate your interest in Park 220, Elk City’s premier apartment community. A team member will be in touch soon to assist you!",
  "property_seo_title_pets": "Pet Policy | Apartments in Elk City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293569958",
  "amenities": [
    {
      "id": "ec_1ee10d2525b67f1dfa585a8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking at No Extra Charge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88a82945065715ad8ff5636b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Newly Remodeled Laundry Room with 24/7 Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df24fc8786e088b5938c30ce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Seasonal Access to the Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e980fdcea10b6d3eb4aadbef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Maintenance On Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7aae3ae88a20f33895b182c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fde1f0eee25944e9694affb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Property Manager On Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdd683ed56cb204081f8dd8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke‑Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c2cd6e951111d92c623cb36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_915236a7cf96ae2262b5f5f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer Hookup*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ef3676efdaa4800b6750fa8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e7b0bb88b14f839a84a6898",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_595f8b45ddf07ee3e22c4b55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a046c12c8593909bbf28dcb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Units Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f54af796f41af0cf7c7e10e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebaeb7e514945ef20ddb68be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a1498ae1-5f32-4ffa-bd7a-3d071c306485",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-e779-75bb-a648-407d3b3e686e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb451-e779-75bb-a648-407d3b3e686e",
        "storage_key": "property/6767906449166978/019fb451-e779-75bb-a648-407d3b3e686e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the community swimming pool, perfect for relaxation and fun on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/0d6607af-f870-45b3-afdd-ca785248d19d"
    },
    {
      "id": "custom_5a7f3c7a-b92d-45e1-a221-7d61b584edda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-e817-7523-ac19-c075298bdd4b.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment with light gray walls and wood-look flooring.",
        "public_id": "019fb451-e817-7523-ac19-c075298bdd4b",
        "storage_key": "property/6767906449166978/019fb451-e817-7523-ac19-c075298bdd4b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A spacious dining area adjacent to a functional kitchen, featuring light gray walls and modern wood-look flooring. Perfect for everyday living.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment with light gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/525cb418-8272-4d7a-a642-7007ccab1cb5"
    },
    {
      "id": "custom_bc76b5de-6311-47ce-b6d7-adfd330df170",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-e7af-719b-a90f-83d07ae60e9a.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, white countertops, a double sink, a white stove, and a white refrigerator.",
        "public_id": "019fb451-e7af-719b-a90f-83d07ae60e9a",
        "storage_key": "property/6767906449166978/019fb451-e7af-719b-a90f-83d07ae60e9a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring white cabinets and countertops, a double sink, and a full suite of appliances including a stove and refrigerator.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, white countertops, a double sink, a white stove, and a white refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/906fd274-7166-4490-9415-f7015759a2c9"
    },
    {
      "id": "custom_1fc3baec-0daa-40db-a59c-11a8a1c6e85e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-e818-75c5-9097-7db7d0c67db3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge chairs with apartment buildings in the background.",
        "public_id": "019fb451-e818-75c5-9097-7db7d0c67db3",
        "storage_key": "property/6767906449166978/019fb451-e818-75c5-9097-7db7d0c67db3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge chairs with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/f4de1bc2-7dd2-47d4-987f-57fd06970e16"
    },
    {
      "id": "custom_defb01c9-a264-498d-973b-4433afa488bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-f2c0-7314-9477-494297bd3ad8.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances including a stove, refrigerator, and microwave, and a double sink.",
        "public_id": "019fb451-f2c0-7314-9477-494297bd3ad8",
        "storage_key": "property/6767906449166978/019fb451-f2c0-7314-9477-494297bd3ad8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring ample cabinet space, a stove, refrigerator, microwave, and a double sink. Perfect for all your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white appliances including a stove, refrigerator, and microwave, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/00e1d585-565a-49ab-8797-9715f9da4c12"
    },
    {
      "id": "custom_5f486994-762e-45e5-b4b4-8641ea0c7792",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-f3b6-7028-82bf-f990f11b7c30.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood-look flooring and a large closet.",
        "public_id": "019fb451-f3b6-7028-82bf-f990f11b7c30",
        "storage_key": "property/6767906449166978/019fb451-f3b6-7028-82bf-f990f11b7c30.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A spacious bedroom with ample closet space, perfect for comfortable living. Features modern wood-look flooring and a neutral color palette.",
      "link": "",
      "alt_text": "Empty bedroom with wood-look flooring and a large closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/a0515ea3-62f8-4ca8-ad76-b4fd201ec954"
    },
    {
      "id": "custom_78b1a1f5-d0b4-4df3-8b77-dd4188c30a99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-f46a-73d8-871b-4f8a47389f0d.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, cabinets, and countertops.",
        "public_id": "019fb451-f46a-73d8-871b-4f8a47389f0d",
        "storage_key": "property/6767906449166978/019fb451-f46a-73d8-871b-4f8a47389f0d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white appliances, ample cabinet space, and a double sink. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white appliances, cabinets, and countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/8be17a63-90d7-40d9-872e-3663bf6de2dd"
    },
    {
      "id": "custom_2203533d-1f9e-4c67-b9b3-5b042cf5ff6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb451-fbfa-722e-81c5-c2831bd6c5e6.webp",
      "image_media": {
        "alt_text": "Empty living room with a white fireplace and a door.",
        "public_id": "019fb451-fbfa-722e-81c5-c2831bd6c5e6",
        "storage_key": "property/6767906449166978/019fb451-fbfa-722e-81c5-c2831bd6c5e6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy white brick fireplace and a neutral color palette. Plenty of natural light enters through the sliding glass door.",
      "link": "",
      "alt_text": "Empty living room with a white fireplace and a door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/2915b4af-cb1a-4510-bcb7-c98c0f78f636"
    },
    {
      "id": "custom_6aeff58d-97f4-4a64-90ee-ea9c58c41378",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-0176-7741-b441-2a2efa947f8d.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines, dryers, a vending machine, and a laundry cart.",
        "public_id": "019fb452-0176-7741-b441-2a2efa947f8d",
        "storage_key": "property/6767906449166978/019fb452-0176-7741-b441-2a2efa947f8d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers, dryers, and a vending machine for your laundry needs.",
      "link": "",
      "alt_text": "Laundry room with multiple washing machines, dryers, a vending machine, and a laundry cart.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/e10bc716-b449-477c-8fac-ee8001c7134d"
    },
    {
      "id": "custom_e4c44650-7522-4a5a-9678-a4a0c04d5c1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-00d4-778b-9bb9-b9678ce56dfe.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool and surrounding buildings.",
        "public_id": "019fb452-00d4-778b-9bb9-b9678ce56dfe",
        "storage_key": "property/6767906449166978/019fb452-00d4-778b-9bb9-b9678ce56dfe.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling blue swimming pool at our community. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Apartment complex swimming pool and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/faa34279-69c2-4595-b29b-3bd6b1d97b70"
    },
    {
      "id": "custom_dd904cc2-ebea-4772-90a9-b5de895c7a1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-055a-71e7-8214-4823887e9f09.webp",
      "image_media": {
        "alt_text": "Community laundry room with multiple washing machines and dryers, seating area, and refrigerator.",
        "public_id": "019fb452-055a-71e7-8214-4823887e9f09",
        "storage_key": "property/6767906449166978/019fb452-055a-71e7-8214-4823887e9f09.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with numerous washers and dryers, a comfortable seating area, and a refrigerator for resident use.",
      "link": "",
      "alt_text": "Community laundry room with multiple washing machines and dryers, seating area, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/36914d0b-37ef-44b3-9f14-9e02a43002c3"
    },
    {
      "id": "custom_f2522059-bc03-4432-bd46-e82ceb38f4ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-0b2c-712e-8c60-58cb60115130.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and shelving unit.",
        "public_id": "019fb452-0b2c-712e-8c60-58cb60115130",
        "storage_key": "property/6767906449166978/019fb452-0b2c-712e-8c60-58cb60115130.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a single sink vanity with ample storage, a toilet with an over-the-toilet shelving unit, and wood-look flooring.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, toilet, and shelving unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/2ed36407-4ec8-476d-a726-5c053f4e87d1"
    },
    {
      "id": "custom_3266af94-4fc6-45fb-a61c-92bd1a50f395",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-1093-74b9-872e-4e0bf19d4e24.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, toilet, and bathtub.",
        "public_id": "019fb452-1093-74b9-872e-4e0bf19d4e24",
        "storage_key": "property/6767906449166978/019fb452-1093-74b9-872e-4e0bf19d4e24.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Updated bathroom featuring a vanity with a sink and ample counter space, a mirror, a toilet, and a bathtub/shower combination.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, mirror, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/66ac97a0-2697-4ec7-b761-6560060289af"
    },
    {
      "id": "custom_014a8e4c-0cdf-42f7-a022-fafd4aeec902",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-0f11-719a-9cc6-92375d3f6c12.webp",
      "image_media": {
        "alt_text": "Bathroom with a shower, toilet, and vanity with a sink and mirror.",
        "public_id": "019fb452-0f11-719a-9cc6-92375d3f6c12",
        "storage_key": "property/6767906449166978/019fb452-0f11-719a-9cc6-92375d3f6c12.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a tub/shower combo, toilet, and a vanity with a sink and ample counter space.",
      "link": "",
      "alt_text": "Bathroom with a shower, toilet, and vanity with a sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/66e09084-f2e0-4358-a470-9464307b2558"
    },
    {
      "id": "custom_ca2874c8-71d1-4653-a1f1-1f936c82be4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-1546-7152-84dd-544ccc5edf16.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light gray walls, a closet, and wood-look flooring.",
        "public_id": "019fb452-1546-7152-84dd-544ccc5edf16",
        "storage_key": "property/6767906449166978/019fb452-1546-7152-84dd-544ccc5edf16.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring neutral gray walls, a spacious closet with bi-fold doors, and modern wood-look flooring. Ample space for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with light gray walls, a closet, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/c6335171-0233-4526-91b3-fa6cf5b4dc93"
    },
    {
      "id": "custom_b641c56c-2321-4dd4-9b3e-aa540b6bccd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-1877-76fe-90de-da88bf602a5d.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window and wood-look flooring.",
        "public_id": "019fb452-1877-76fe-90de-da88bf602a5d",
        "storage_key": "property/6767906449166978/019fb452-1877-76fe-90de-da88bf602a5d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A blank canvas awaits! This spacious bedroom features a large window for natural light and stylish wood-look flooring, ready for you to make it your own.",
      "link": "",
      "alt_text": "Empty bedroom with a window and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/9364d979-2d13-4980-a95b-1b75072dfa5b"
    },
    {
      "id": "custom_2a503958-971e-46de-98d8-15bb6e832e1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-1bb0-7292-b947-aebf04da29f8.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, vanity, and mirror",
        "public_id": "019fb452-1bb0-7292-b947-aebf04da29f8",
        "storage_key": "property/6767906449166978/019fb452-1bb0-7292-b947-aebf04da29f8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, toilet, and vanity with ample counter space and a large mirror.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, vanity, and mirror",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/c0869f7f-dfed-49f8-b4f9-34ebd90074a6"
    },
    {
      "id": "custom_7bd027ce-0a3d-49be-a335-7eff3983cc32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-1b74-7314-a92a-f1aaa8a41c49.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, electric stove, and stainless steel sink.",
        "public_id": "019fb452-1b74-7314-a92a-f1aaa8a41c49",
        "storage_key": "property/6767906449166978/019fb452-1b74-7314-a92a-f1aaa8a41c49.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinets, a white electric stove, and a double stainless steel sink. Ample space for a dining area.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, electric stove, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/733febbe-d4b7-4e42-a50f-26f278b2e470"
    },
    {
      "id": "custom_77c7086c-6ea9-4258-a5d3-8ad908db7c23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-204e-7372-afc2-1884e6d29c31.webp",
      "image_media": {
        "alt_text": "Bedroom with wood-look flooring, ceiling fan, and closet.",
        "public_id": "019fb452-204e-7372-afc2-1884e6d29c31",
        "storage_key": "property/6767906449166978/019fb452-204e-7372-afc2-1884e6d29c31.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring wood-look flooring, a ceiling fan, and ample closet space. The adjacent bathroom is visible.",
      "link": "",
      "alt_text": "Bedroom with wood-look flooring, ceiling fan, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/e2200cd9-5ae1-4be9-ba99-91989f35ba61"
    },
    {
      "id": "custom_4c8c18e2-4573-4e4b-a1e4-7b3578c653b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-2426-777f-a2f7-a6ddecfc0ce8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light gray walls and wood-look flooring.",
        "public_id": "019fb452-2426-777f-a2f7-a6ddecfc0ce8",
        "storage_key": "property/6767906449166978/019fb452-2426-777f-a2f7-a6ddecfc0ce8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a ceiling fan and a large window, offering a comfortable and versatile living space.",
      "link": "",
      "alt_text": "Empty bedroom with light gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/1c93e6c4-5c2b-4ec1-a29f-f241d826f7e6"
    },
    {
      "id": "custom_5335f9b4-3d13-4a08-86ff-2bb1fe6913c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-264d-7238-9705-89fd6fe143a7.webp",
      "image_media": {
        "alt_text": "Kitchen area with white appliances including a refrigerator and stove, light grey cabinets, and light wood-look flooring.",
        "public_id": "019fb452-264d-7238-9705-89fd6fe143a7",
        "storage_key": "property/6767906449166978/019fb452-264d-7238-9705-89fd6fe143a7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Explore the functional kitchen space, featuring essential appliances and ample cabinet storage, perfect for everyday cooking.",
      "link": "",
      "alt_text": "Kitchen area with white appliances including a refrigerator and stove, light grey cabinets, and light wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/0828cfac-600a-4bea-9665-3caa5406d5fd"
    },
    {
      "id": "custom_693b1ded-f30f-4faf-9c65-ce426a41d4e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-25fe-738f-a3e4-38b6c562b75d.webp",
      "image_media": {
        "alt_text": "Living room and kitchen view of an apartment.",
        "public_id": "019fb452-25fe-738f-a3e4-38b6c562b75d",
        "storage_key": "property/6767906449166978/019fb452-25fe-738f-a3e4-38b6c562b75d.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Spacious living area with modern wood-look flooring. The adjoining kitchen features sleek cabinetry and countertops, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen view of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/11705049-feb0-4253-9f5b-c5880a90af1f"
    },
    {
      "id": "custom_0b1d14f2-c4dc-4bc8-b8ae-452c95e720d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-2aad-71fc-a449-2c0c8e643fd6.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, refrigerator, stove, and dishwasher.",
        "public_id": "019fb452-2aad-71fc-a449-2c0c8e643fd6",
        "storage_key": "property/6767906449166978/019fb452-2aad-71fc-a449-2c0c8e643fd6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring white cabinets, a white refrigerator, a white stove, and a dishwasher, with modern wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, refrigerator, stove, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/8d7b70a0-8a57-47ce-8a26-5da7b5e26461"
    },
    {
      "id": "custom_4c0a4559-ba65-4aa4-8292-ced7ec5e91cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-2e44-7471-b429-813f282678db.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a view of the kitchen pass-through.",
        "public_id": "019fb452-2e44-7471-b429-813f282678db",
        "storage_key": "property/6767906449166978/019fb452-2e44-7471-b429-813f282678db.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a white brick fireplace and wood-look flooring, leading into a modern kitchen area with a breakfast bar.",
      "link": "",
      "alt_text": "Living room with a fireplace and a view of the kitchen pass-through.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/dcee7a9c-974b-449f-bb2c-eebe47a1fa48"
    },
    {
      "id": "custom_c71b53d2-063f-47b5-bbc7-53c3f716d95e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-30eb-7717-831a-fe195f397234.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily property with brick and siding, featuring a circular window and parking lot.",
        "public_id": "019fb452-30eb-7717-831a-fe195f397234",
        "storage_key": "property/6767906449166978/019fb452-30eb-7717-831a-fe195f397234.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "This image showcases the exterior of the multifamily property, highlighting its architectural features and the surrounding parking area. The building combines brick and light blue siding, with a distinctive circular window and ample parking for residents.",
      "link": "",
      "alt_text": "Exterior view of a multifamily property with brick and siding, featuring a circular window and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/53081800-bf67-4f34-a3dc-f4bae50b7d43"
    },
    {
      "id": "custom_44392e3f-c5cc-4b6f-81f8-a9891bff3bd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-3148-7500-95f7-ce5f85b7bb50.webp",
      "image_media": {
        "alt_text": "Exterior walkway overlooking brick apartment buildings with balconies and railings.",
        "public_id": "019fb452-3148-7500-95f7-ce5f85b7bb50",
        "storage_key": "property/6767906449166978/019fb452-3148-7500-95f7-ce5f85b7bb50.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "View of the exterior walkways and brick buildings, highlighting the apartment complex's architecture and outdoor spaces.",
      "link": "",
      "alt_text": "Exterior walkway overlooking brick apartment buildings with balconies and railings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/5d802ae3-21c3-4cc9-9aab-d307f04f2fbc"
    },
    {
      "id": "custom_3f0007d7-8eca-4c68-8c23-95fa17902fc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-3581-768c-a8f7-b4a33c4779af.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and mirror.",
        "public_id": "019fb452-3581-768c-a8f7-b4a33c4779af",
        "storage_key": "property/6767906449166978/019fb452-3581-768c-a8f7-b4a33c4779af.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, toilet, and a wooden vanity with a sink and a large mirror.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/0585cbf2-e526-401d-bb45-1bdadacf8ef6"
    },
    {
      "id": "custom_a613faa7-35ec-4456-8f83-88fd8190efb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-39a1-749a-bbe2-df150dfdcf41.webp",
      "image_media": {
        "alt_text": "Empty bedroom with grey walls and wood-look flooring",
        "public_id": "019fb452-39a1-749a-bbe2-df150dfdcf41",
        "storage_key": "property/6767906449166978/019fb452-39a1-749a-bbe2-df150dfdcf41.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This is an empty bedroom with neutral grey walls, wood-look vinyl plank flooring, and a window with blinds. Perfect for personalizing your space.",
      "link": "",
      "alt_text": "Empty bedroom with grey walls and wood-look flooring",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/f2a9cb15-91bb-44c1-b661-2eaf3c5b6ea7"
    },
    {
      "id": "custom_cba6de9a-95a9-4e29-9d17-3a51c16d9446",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-3c66-74f9-9ad0-895933b3151c.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "019fb452-3c66-74f9-9ad0-895933b3151c",
        "storage_key": "property/6767906449166978/019fb452-3c66-74f9-9ad0-895933b3151c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a spacious vanity with a large mirror, a modern sink, a toilet, and a bathtub with a shower head.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/210158cc-3077-46d5-bdaa-070a29820154"
    },
    {
      "id": "custom_097f65a4-9558-4bbf-a3e2-2d8bb2f27d84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-3c87-750f-9bca-6ef674aedded.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand with a lamp, and a dresser.",
        "public_id": "019fb452-3c87-750f-9bca-6ef674aedded",
        "storage_key": "property/6767906449166978/019fb452-3c87-750f-9bca-6ef674aedded.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a queen-size bed, convenient nightstand with a lamp, and a spacious dresser for all your storage needs.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand with a lamp, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/4601ffce-2831-425d-b7ad-91a4f85abf75"
    },
    {
      "id": "custom_b58392ac-86c7-4a61-bf03-27d34894b4cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-4066-7612-b591-1cd96e3a9773.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and light gray walls.",
        "public_id": "019fb452-4066-7612-b591-1cd96e3a9773",
        "storage_key": "property/6767906449166978/019fb452-4066-7612-b591-1cd96e3a9773.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Apartment",
      "description": "Compact kitchen featuring white appliances including a stove, refrigerator, and microwave. Ample wood cabinetry provides storage, complemented by light gray walls and dark wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, and light gray walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/a865b42a-bc88-4641-b990-22f5d95caf77"
    },
    {
      "id": "custom_e5a52624-970c-4040-8207-0c53bd347647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-43c6-70be-8b3d-2765f966e5d3.webp",
      "image_media": {
        "alt_text": "Empty living room with light blue walls and wood-look flooring.",
        "public_id": "019fb452-43c6-70be-8b3d-2765f966e5d3",
        "storage_key": "property/6767906449166978/019fb452-43c6-70be-8b3d-2765f966e5d3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and bright living area featuring light blue walls and durable wood-look flooring, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty living room with light blue walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/33ff361e-da2b-4871-baf6-98081c16def5"
    },
    {
      "id": "custom_c1da850c-b039-4c79-a168-dd3a4325a9f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019fb452-46c8-711d-8613-ba586085b41b.webp",
      "image_media": {
        "alt_text": "Empty living room with a white door and a sliding glass door.",
        "public_id": "019fb452-46c8-711d-8613-ba586085b41b",
        "storage_key": "property/6767906449166978/019fb452-46c8-711d-8613-ba586085b41b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and well-lit living area with modern wood-look flooring and neutral walls, offering a blank canvas for your personal style.",
      "link": "",
      "alt_text": "Empty living room with a white door and a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/7ca776bd-8d92-407b-b8b4-8b8bb96d35d1"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1f57a7ca-ea36-4b04-8d85-69848a6dce82",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Main Street Coffee & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "101 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Relaxed coffeehouse offering breakfast, panini, and desserts such as muffins.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-0500-750b-bf64-d5ffa7b71a53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0500-750b-bf64-d5ffa7b71a53",
        "storage_key": "property/6767906449166978/019d08b6-0500-750b-bf64-d5ffa7b71a53.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435893153750745973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-coffee--cafe",
      "poi_latitude": "35.4108531",
      "poi_longitude": "-99.4051373",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-339-8252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f4e-71c9-bcec-5e484e0ee7dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f4e-71c9-bcec-5e484e0ee7dd",
        "storage_key": "property/6767906449166978/019d08b6-6f4e-71c9-bcec-5e484e0ee7dd.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJB3kPFATlq4cRdYM-F4i905A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_db7c461e-5f48-4306-86b0-6f2e2b8af6af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Eye Opener Coffee & Smoothie House",
      "poi_type": "Restaurants",
      "poi_address": "920 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-04e4-765c-83e1-4800cfe05267.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-04e4-765c-83e1-4800cfe05267",
        "storage_key": "property/6767906449166978/019d08b6-04e4-765c-83e1-4800cfe05267.webp",
        "width": 1008,
        "height": 756
      },
      "poi_business_url": "http://eyeopenercoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14763122383082018315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eye-opener-coffee--smoothie-house",
      "poi_latitude": "35.419042",
      "poi_longitude": "-99.4045261",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-339-6818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f4e-71c9-bcec-5e484e0ee7dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f4e-71c9-bcec-5e484e0ee7dd",
        "storage_key": "property/6767906449166978/019d08b6-6f4e-71c9-bcec-5e484e0ee7dd.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ4fAir5Tlq4cRC9Y4y5Yl4cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_903baf92-4934-4a43-bfce-0f10e3415f83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "White Buffalo Coffee Bar",
      "poi_type": "Restaurants",
      "poi_address": "1522 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Espresso drinks, teas, and sweet or savory snacks offered in a relaxed coffeehouse with a drive through.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-091b-75ba-8789-55c53392126c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-091b-75ba-8789-55c53392126c",
        "storage_key": "property/6767906449166978/019d08b6-091b-75ba-8789-55c53392126c.webp",
        "width": 1280,
        "height": 642
      },
      "poi_business_url": "http://www.whitebuffalocoffeebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14805760688878670642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-buffalo-coffee-bar",
      "poi_latitude": "35.4113467",
      "poi_longitude": "-99.4228371",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-9562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f4e-71c9-bcec-5e484e0ee7dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f4e-71c9-bcec-5e484e0ee7dd",
        "storage_key": "property/6767906449166978/019d08b6-6f4e-71c9-bcec-5e484e0ee7dd.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJKyArjbnlq4cRMlMO-uageM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_b39ebf18-d4ca-4ef0-9c47-aeb9473b026e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Janice's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2103 S Main St STE A, Elk City, OK 73644, USA",
      "poi_short_description": "Breakfast spot, burger eatery and cafe serving up familiar eats and fried pies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-07a8-746b-86a5-c8d1122daa10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-07a8-746b-86a5-c8d1122daa10",
        "storage_key": "property/6767906449166978/019d08b6-07a8-746b-86a5-c8d1122daa10.webp",
        "width": 1280,
        "height": 898
      },
      "poi_business_url": "http://janicescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9114988415775329117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "janices-cafe",
      "poi_latitude": "35.3907003",
      "poi_longitude": "-99.4053329",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-303-9022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPzPUO3Dlq4cRXcsWvqvxfn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0737b0e9-0b20-4ee3-9f4e-42a5b680f2c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Huddle House",
      "poi_type": "Restaurants",
      "poi_address": "103 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "Diner-style restaurant serving up breakfast and American fare in a relaxed setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-0b0d-77a5-87f9-27823fbca9b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0b0d-77a5-87f9-27823fbca9b6",
        "storage_key": "property/6767906449166978/019d08b6-0b0d-77a5-87f9-27823fbca9b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://huddlehouse.com/locations/ok/elk-city/103-regional-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=8851458752709510619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huddle-house",
      "poi_latitude": "35.4084214",
      "poi_longitude": "-99.379689",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-4505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyrTiQPlq4cR28VFq9ay1no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_97a662f2-ce88-4edb-85b3-3e8fa7c48707",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Fred's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "2107 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Casual steakhouse featuring steaks and chicken-fried steak plus salads and desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-0d7e-773c-bac1-f9187c113a9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0d7e-773c-bac1-f9187c113a9c",
        "storage_key": "property/6767906449166978/019d08b6-0d7e-773c-bac1-f9187c113a9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fredssteakhouseok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18151492439674936462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freds-steakhouse",
      "poi_latitude": "35.3902897",
      "poi_longitude": "-99.4050825",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-243-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxhbLPXlq4cRjlwDAjQO5_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_eb8703b0-d2ac-49e0-a673-2807562122a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Lupes Mexican restaurant",
      "poi_type": "Restaurants",
      "poi_address": "905 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Chilled salsa, hot plates and friendly service at a traditional Mexican restaurant featuring a variety of meals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-0ed6-7179-8fb0-9334a574e83a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0ed6-7179-8fb0-9334a574e83a",
        "storage_key": "property/6767906449166978/019d08b6-0ed6-7179-8fb0-9334a574e83a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4756226892613525272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lupes-mexican-restaurant",
      "poi_latitude": "35.41871",
      "poi_longitude": "-99.4051525",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-7109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSi87knlq4cRGJ9jxSiDAUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_131dad59-6429-4479-8286-f21df55506e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "El Patio | Mexican Grill And Cantina",
      "poi_type": "Restaurants",
      "poi_address": "301 N Eastern Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Mexican, Latin American eatery dishing up fajitas, enchiladas, nachos, tacos and tortas amid relaxed vibes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-109d-70a2-87fa-ef558c2e5dc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-109d-70a2-87fa-ef558c2e5dc6",
        "storage_key": "property/6767906449166978/019d08b6-109d-70a2-87fa-ef558c2e5dc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://elpatiorestaurantsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=168899378546299304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-patio--mexican-grill-and-cantina",
      "poi_latitude": "35.4120934",
      "poi_longitude": "-99.382235",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-303-7372",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK2tonDDlq4cRqFEJBRcNWAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_fec0632f-87ed-4413-977f-573e6da56b5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Roma's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2700 E State Hwy 66, Elk City, OK 73644, USA",
      "poi_short_description": "Italian meals including pizza are offered in this restaurant with gluten-free options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-120f-774f-88d9-314bdb3d9d31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-120f-774f-88d9-314bdb3d9d31",
        "storage_key": "property/6767906449166978/019d08b6-120f-774f-88d9-314bdb3d9d31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16430477998309993501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "romas-restaurant",
      "poi_latitude": "35.4211278",
      "poi_longitude": "-99.3723707",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-8881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwwE59Xkq4cRHWwj46_IBOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c9848fbf-70ed-4f5a-b674-756ab9c8ad29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "China Super Buffet",
      "poi_type": "Restaurants",
      "poi_address": "2103 S Main St i, Elk City, OK 73644, USA",
      "poi_short_description": "All-you-can-eat Chinese spot offering familiar favorites in a casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-14c4-7113-ad2a-5f1d659b888e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-14c4-7113-ad2a-5f1d659b888e",
        "storage_key": "property/6767906449166978/019d08b6-14c4-7113-ad2a-5f1d659b888e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://china-super-buffet-elk-city.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=513497943391033164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-super-buffet",
      "poi_latitude": "35.3909055",
      "poi_longitude": "-99.4067092",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQEilnPlq4cRTFe3rKhPIAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_0503ea05-bf50-47f3-97bb-fb8604b9d5fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Golden China Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "101 Janets Way, Elk City, OK 73644, USA",
      "poi_short_description": "Casual Chinese restaurant offering an all-you-can-eat buffet at lunch and dinner.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-15d5-7635-bc8b-c96503708062.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-15d5-7635-bc8b-c96503708062",
        "storage_key": "property/6767906449166978/019d08b6-15d5-7635-bc8b-c96503708062.webp",
        "width": 1280,
        "height": 557
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2087759420774332214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-china-restaurant",
      "poi_latitude": "35.4111233",
      "poi_longitude": "-99.4398791",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-eiicvlq4cRNre6uyE2-Rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_db0eddca-e7d2-4168-893a-c6c2c822ce38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Pizza Hut",
      "poi_type": "Restaurants",
      "poi_address": "1120 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_long_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-17c2-714a-b27f-8c9586332271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-17c2-714a-b27f-8c9586332271",
        "storage_key": "property/6767906449166978/019d08b6-17c2-714a-b27f-8c9586332271.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.pizzahut.com/ok/elk-city/1120-w-3rd-st?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=283636",
      "poi_directions_map_url": "https://maps.google.com/?cid=7734630930614462126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-hut",
      "poi_latitude": "35.4113648",
      "poi_longitude": "-99.4178045",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-1160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWDbEKzlq4cRriYGANrtVms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_delivery"
    },
    {
      "id": "custom_087aae5c-fb0c-4f55-9e87-d88ff865de86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Domino's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1029 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Delivery/carryout chain offering a wide range of pizzas & a variety of other dishes & sides.",
      "poi_long_description": "Delivery/carryout chain offering a wide range of pizzas & a variety of other dishes & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-1865-747d-81d8-f8cba5d188fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1865-747d-81d8-f8cba5d188fc",
        "storage_key": "property/6767906449166978/019d08b6-1865-747d-81d8-f8cba5d188fc.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.dominos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4822528213851314506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominos-pizza",
      "poi_latitude": "35.4120919",
      "poi_longitude": "-99.4168919",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-303-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUVP8qvlq4cRShnoEdwP7UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_delivery"
    },
    {
      "id": "custom_5a981b75-f179-4f2d-97c5-b6e86170134c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Chuck's Place",
      "poi_type": "Restaurants",
      "poi_address": "308 N Van Buren Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Casual diner offering breakfast and comfort food such as burgers, cheesesteaks, and pancakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-1c9d-7279-812c-df001bce87f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1c9d-7279-812c-df001bce87f7",
        "storage_key": "property/6767906449166978/019d08b6-1c9d-7279-812c-df001bce87f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9093571839821610350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chucks-place",
      "poi_latitude": "35.4133154",
      "poi_longitude": "-99.3992635",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-303-4737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f35-734d-afd2-b776d62a50b3",
        "storage_key": "property/6767906449166978/019d08b6-6f35-734d-afd2-b776d62a50b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyG9uBzlq4cRbv0PlGjbMn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_fe590386-9c7a-468a-8e3a-f5d60d22950d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "210 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-1d60-7078-916b-54a66b20ab8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1d60-7078-916b-54a66b20ab8f",
        "storage_key": "property/6767906449166978/019d08b6-1d60-7078-916b-54a66b20ab8f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/134-elk-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13682067315935966193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.4092259",
      "poi_longitude": "-99.3764982",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f53-737c-9c3f-da061bfd04bb",
        "storage_key": "property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVbfAHUEGsocR8XNYr7t34L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f6979240-6b6a-4bcd-b60e-f8e996c77b81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Homeland Stores",
      "poi_type": "Shopping & Retail",
      "poi_address": "412 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Meat and produce retailer and bakery offering groceries, a deli and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2056-72fc-b5c3-44ffe293021a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2056-72fc-b5c3-44ffe293021a",
        "storage_key": "property/6767906449166978/019d08b6-2056-72fc-b5c3-44ffe293021a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.homelandstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2543207406463372022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homeland-stores",
      "poi_latitude": "35.4112629",
      "poi_longitude": "-99.4091792",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-0322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7416-70ff-b9c2-da0fc3084c8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7416-70ff-b9c2-da0fc3084c8c",
        "storage_key": "property/6767906449166978/019d08b6-7416-70ff-b9c2-da0fc3084c8c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6bl1ADlq4cR9kpkZKlJSyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_782c88af-bb32-492e-a5a0-1d1a0d6bee87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "United Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Grocery chain offering fresh produce, meats, and other staples, plus a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-1e41-778a-9883-54a38893c666.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1e41-778a-9883-54a38893c666",
        "storage_key": "property/6767906449166978/019d08b6-1e41-778a-9883-54a38893c666.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.unitedok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8335024647888070576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-supermarkets",
      "poi_latitude": "35.4104806",
      "poi_longitude": "-99.4360301",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7416-70ff-b9c2-da0fc3084c8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7416-70ff-b9c2-da0fc3084c8c",
        "storage_key": "property/6767906449166978/019d08b6-7416-70ff-b9c2-da0fc3084c8c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15g_Usrlq4cRsGd-o8H0q3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_93a18437-48c2-4f88-abdc-9eec0a9cea9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Grandview Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1220 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2444-7256-800c-74e8cbd37736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2444-7256-800c-74e8cbd37736",
        "storage_key": "property/6767906449166978/019d08b6-2444-7256-800c-74e8cbd37736.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6679962756916231400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grandview-pharmacy",
      "poi_latitude": "35.4114724",
      "poi_longitude": "-99.4191271",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-5550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7460-70ce-8787-ebf0ba218c45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7460-70ce-8787-ebf0ba218c45",
        "storage_key": "property/6767906449166978/019d08b6-7460-70ce-8787-ebf0ba218c45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdyoPazlq4cR6LzURrz-s1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_546ebfe8-1ce4-4b39-996e-b4a53e9f7046",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "111 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2781-7058-8555-258f2f959fa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2781-7058-8555-258f2f959fa5",
        "storage_key": "property/6767906449166978/019d08b6-2781-7058-8555-258f2f959fa5.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ok/elk-city/24072",
      "poi_directions_map_url": "https://maps.google.com/?cid=16593258602754596617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.4111915",
      "poi_longitude": "-99.405132",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-653-9390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f53-737c-9c3f-da061bfd04bb",
        "storage_key": "property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSauLFATlq4cRCd9hy8gYR-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_15db1bae-7d15-43c5-a915-bdc4f69a34aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3005 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2ae7-7376-9165-f81274ff1b7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2ae7-7376-9165-f81274ff1b7c",
        "storage_key": "property/6767906449166978/019d08b6-2ae7-7376-9165-f81274ff1b7c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/ok/elk-city/3005-w-3rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8010885970593462857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "35.4127494",
      "poi_longitude": "-99.4431854",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-303-4393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f53-737c-9c3f-da061bfd04bb",
        "storage_key": "property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgzD9VMflq4cRSTpixVhiLG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_44820f20-f715-45df-afcc-fb2b9073ee20",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Hutch's",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 Clyde Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2abc-739b-ad7e-32ddf692f23e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2abc-739b-ad7e-32ddf692f23e",
        "storage_key": "property/6767906449166978/019d08b6-2abc-739b-ad7e-32ddf692f23e.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.hutchs.net/101-clyde-street/?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4623876941441490679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hutchs",
      "poi_latitude": "35.4212655",
      "poi_longitude": "-99.382442",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-6531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-748f-7209-a70b-5b23a714f3ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-748f-7209-a70b-5b23a714f3ab",
        "storage_key": "property/6767906449166978/019d08b6-748f-7209-a70b-5b23a714f3ab.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJa9BfFXHlq4cR9169c5RPK0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_176b0707-3055-4689-ac9d-77c1d79fb371",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "580 Threads",
      "poi_type": "Shopping & Retail",
      "poi_address": "105 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Stylish shop featuring clothing, gifts, accessories and tees.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2d25-758d-b169-afe6335bfb04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2d25-758d-b169-afe6335bfb04",
        "storage_key": "property/6767906449166978/019d08b6-2d25-758d-b169-afe6335bfb04.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.580threads.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7451210335686390391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "580-threads",
      "poi_latitude": "35.4109602",
      "poi_longitude": "-99.4052087",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-303-7123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f53-737c-9c3f-da061bfd04bb",
        "storage_key": "property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_5CqfwPlq4cRd3JOdVIEaGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_4e7cb240-cbdb-4fdf-a888-612516c67434",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Elementary",
      "poi_type": "Education",
      "poi_address": "2801 BG Buckley, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2d9f-7759-8aee-3e694d10ee82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2d9f-7759-8aee-3e694d10ee82",
        "storage_key": "property/6767906449166978/019d08b6-2d9f-7759-8aee-3e694d10ee82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11837293182480863845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-elementary",
      "poi_latitude": "35.418339",
      "poi_longitude": "-99.4392407",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 580-225-7722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX1sefzTkq4cRZdLsy26DRqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d7f25cdf-4e11-4a12-a1e8-c51e48465f66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Intermediate School",
      "poi_type": "Education",
      "poi_address": "800 N Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14509508519463041516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-intermediate-school",
      "poi_latitude": "35.4175391",
      "poi_longitude": "-99.4340963",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-2687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJydNsgUrkq4cR7DkZsB8hXMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_430931b5-29e3-4cf0-8c83-195cceb83df3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Middle School",
      "poi_type": "Education",
      "poi_address": "400 N Boone Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.elkcityschools.com/o/ecms",
      "poi_directions_map_url": "https://maps.google.com/?cid=6379857624794786955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-middle-school",
      "poi_latitude": "35.4143062",
      "poi_longitude": "-99.412242",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-5043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMRj5aqrlq4cRi-x1M7XOiVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9038f0da-78d0-4a55-bbd6-91cfcce92caf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City High School",
      "poi_type": "Education",
      "poi_address": "1221 Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-31f7-70a3-8147-f8d8d809c579.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-31f7-70a3-8147-f8d8d809c579",
        "storage_key": "property/6767906449166978/019d08b6-31f7-70a3-8147-f8d8d809c579.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15035490388081745347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-high-school",
      "poi_latitude": "35.4203238",
      "poi_longitude": "-99.4353527",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-0105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJox3KETbkq4cRw51ptdjKqNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_6ce1ce27-3335-4a37-a506-35f501249fb1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Fairview Elementary School",
      "poi_type": "Education",
      "poi_address": "1502 W 7th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9521912981399062367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairview-elementary-school",
      "poi_latitude": "35.40812349999999",
      "poi_longitude": "-99.4222701",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-2590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_yxDzq_lq4cRX8d4RmihJIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_24d7a85e-6493-4096-be4b-fc1357be3de9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Western Technology Center - Elk City Campus",
      "poi_type": "Education",
      "poi_address": "301 Western Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-323d-7541-87e6-35eceba6ae67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-323d-7541-87e6-35eceba6ae67",
        "storage_key": "property/6767906449166978/019d08b6-323d-7541-87e6-35eceba6ae67.webp",
        "width": 450,
        "height": 300
      },
      "poi_business_url": "http://www.westtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14465938203486703225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-technology-center---elk-city-campus",
      "poi_latitude": "35.4132766",
      "poi_longitude": "-99.4414978",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-4982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxKwwczlq4cRec6T-SZWwcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_539597a6-97d5-46c9-a5a2-f68253ecad04",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Kids Inc. Elk City",
      "poi_type": "Education",
      "poi_address": "600 Western Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kidsincelkcity.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4424313767318374035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-inc-elk-city",
      "poi_latitude": "35.4165707",
      "poi_longitude": "-99.4400668",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbIsXLXlq4cRk8bhK-5RZj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8c1c9054-b933-4cd7-8885-7e3c0611abfd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Sweet Miracles Daycare",
      "poi_type": "Education",
      "poi_address": "1021 E State Hwy 66, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-341d-73d9-9bca-0c84656ce89b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-341d-73d9-9bca-0c84656ce89b",
        "storage_key": "property/6767906449166978/019d08b6-341d-73d9-9bca-0c84656ce89b.webp",
        "width": 1280,
        "height": 490
      },
      "poi_business_url": "https://www.sweetmiraclesdaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18327863046036666882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-miracles-daycare",
      "poi_latitude": "35.422792",
      "poi_longitude": "-99.3885049",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-339-5024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMwOHSGHlq4cRAjoGz1WmWf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_b364210e-86ea-4b74-a268-84db6f46bdeb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Pitter Patter's Daycare",
      "poi_type": "Education",
      "poi_address": "1705 W 7th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12599233076365250225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitter-patters-daycare",
      "poi_latitude": "35.4075009",
      "poi_longitude": "-99.4256862",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-1467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8_e4S7Dlq4cRsU4at7p32a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_4e9ac6ab-918c-42eb-8700-f8296efcd7db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Lil Angels",
      "poi_type": "Education",
      "poi_address": "103 W 10th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6397161868375137270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lil-angels",
      "poi_latitude": "35.4042897",
      "poi_longitude": "-99.4057752",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_3FVNQDlq4cR9pssX9NIx1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_d5af1066-4ee4-4109-a274-b9803a0186de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "National Route 66 Museum and Transportation Museum",
      "poi_type": "Entertainment",
      "poi_address": "2717 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Museum with historical exhibits on the area, as well as a restroom, and gift shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-3513-72f4-b22c-94f40f5f58c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-3513-72f4-b22c-94f40f5f58c4",
        "storage_key": "property/6767906449166978/019d08b6-3513-72f4-b22c-94f40f5f58c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884788711799271139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-route-66-museum-and-transportation-museum",
      "poi_latitude": "35.4119992",
      "poi_longitude": "-99.4368418",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-3542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-79d5-76dd-ac6a-2996dcc83e4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-79d5-76dd-ac6a-2996dcc83e4d",
        "storage_key": "property/6767906449166978/019d08b6-79d5-76dd-ac6a-2996dcc83e4d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8IqNQHlq4cR4y62YZOIM_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7f3ed515-de45-44ce-b5af-7fc3aa99c2b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Pioneer Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "1221 N Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "Multi-use venue for concerts, theater productions and school events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-3ac5-71ee-85b2-477229548ede.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-3ac5-71ee-85b2-477229548ede",
        "storage_key": "property/6767906449166978/019d08b6-3ac5-71ee-85b2-477229548ede.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17699233493536248314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-performing-arts-center",
      "poi_latitude": "35.4198317",
      "poi_longitude": "-99.4359382",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDwLKETbkq4cR-pHsehZPoPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_bc13d1a6-c47c-420a-b74b-3814667e35e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Ackley Park",
      "poi_type": "Entertainment",
      "poi_address": "Elk City, OK 73644, USA",
      "poi_short_description": "220-acre park with a carousel, softball complex & picnic shelters, plus a seasonal pool & mini-golf.",
      "poi_long_description": "220-acre park with a carousel, softball complex & picnic shelters, plus a seasonal pool & mini-golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-3a3c-75b1-8319-d2ea22daffcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-3a3c-75b1-8319-d2ea22daffcf",
        "storage_key": "property/6767906449166978/019d08b6-3a3c-75b1-8319-d2ea22daffcf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/parks-department/ackley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13973795923092422598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ackley-park",
      "poi_latitude": "35.4129754",
      "poi_longitude": "-99.4333817",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7a14-701c-b7d1-c6d9fc7b31e4",
        "storage_key": "property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2O3ocrlq4cRxr-5D1vl7ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a257445d-ed11-4b04-88bd-abd54c9befd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Beutler & Son Rodeo Co",
      "poi_type": "Entertainment",
      "poi_address": "10239 OK-34, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-3c6d-730e-9a86-26de4521f578.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-3c6d-730e-9a86-26de4521f578",
        "storage_key": "property/6767906449166978/019d08b6-3c6d-730e-9a86-26de4521f578.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14203223524675836368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beutler--son-rodeo-co",
      "poi_latitude": "35.5118004",
      "poi_longitude": "-99.3737375",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 580-225-1079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9c9zgFnkq4cR0FnGNYv8G8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_51d69488-d52d-4e20-91da-8244847d6bb1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Lake Park campground",
      "poi_type": "Entertainment",
      "poi_address": "D1137 Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-3c72-76ea-be23-cacd29a90b49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-3c72-76ea-be23-cacd29a90b49",
        "storage_key": "property/6767906449166978/019d08b6-3c72-76ea-be23-cacd29a90b49.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/parks-department/elk-city-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310627304649885072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-lake-park-campground",
      "poi_latitude": "35.366042",
      "poi_longitude": "-99.4154983",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7a1e-70ea-8695-dc89caa2c130.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7a1e-70ea-8695-dc89caa2c130",
        "storage_key": "property/6767906449166978/019d08b6-7a1e-70ea-8695-dc89caa2c130.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ922FFnnvq4cRkIVFxwLZuLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_7d74ed74-ae78-40f9-aaaf-106034d0d8ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Blockhouse Sports Bar",
      "poi_type": "Entertainment",
      "poi_address": "20096 E 1090 Rd, Elk City, OK 73644, USA",
      "poi_short_description": "Casual establishment featuring a jukebox, billiards and a patio, as well as flat-screen TVs showing sports.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-40a3-7309-9771-1c52af6e62ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-40a3-7309-9771-1c52af6e62ba",
        "storage_key": "property/6767906449166978/019d08b6-40a3-7309-9771-1c52af6e62ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4402833883886254529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blockhouse-sports-bar",
      "poi_latitude": "35.4360351",
      "poi_longitude": "-99.4000091",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7ac0-748d-872f-89286e19c4cd",
        "storage_key": "property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBSDxvIblq4cRwfkXFhcCGj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_10c4efac-5bb3-449f-a4c1-8938f649490a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "The Pitstop",
      "poi_type": "Entertainment",
      "poi_address": "2500 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Lively hangout decked out with a pool table.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-4137-7458-9445-37cebf75afcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-4137-7458-9445-37cebf75afcc",
        "storage_key": "property/6767906449166978/019d08b6-4137-7458-9445-37cebf75afcc.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2491553211345663315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pitstop",
      "poi_latitude": "35.3920402",
      "poi_longitude": "-99.40316",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 580-225-6320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7ac0-748d-872f-89286e19c4cd",
        "storage_key": "property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaShvEVrlq4cRU_U95XHGkyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_16438b84-7420-409a-b1bf-d806277b98e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Knucklehead Red's Saloon",
      "poi_type": "Entertainment",
      "poi_address": "2417 W Broadway Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Casual eatery featuring pool tables, live music and a dancefloor, along with a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-42de-70b9-a101-e66a5af671e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-42de-70b9-a101-e66a5af671e7",
        "storage_key": "property/6767906449166978/019d08b6-42de-70b9-a101-e66a5af671e7.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.facebook.com/steven.beck.5602/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13101340945188146472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knucklehead-reds-saloon",
      "poi_latitude": "35.4110584",
      "poi_longitude": "-99.4337464",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7ac0-748d-872f-89286e19c4cd",
        "storage_key": "property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVV458rXlq4cRKE04_yxQ0bU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_b1000d1f-9505-4e93-be09-a2b08d5ac778",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "End Zone",
      "poi_type": "Entertainment",
      "poi_address": "221 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-42dc-77db-a532-533d406531a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-42dc-77db-a532-533d406531a1",
        "storage_key": "property/6767906449166978/019d08b6-42dc-77db-a532-533d406531a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=312784908429672848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "end-zone",
      "poi_latitude": "35.412587",
      "poi_longitude": "-99.4052985",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-243-2136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7ac0-748d-872f-89286e19c4cd",
        "storage_key": "property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Wx89QPlq4cRkMENjjc8VwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "night_club"
    },
    {
      "id": "custom_764443d3-4304-49b1-925c-4048ba940730",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "The Twisted Mule Saloon",
      "poi_type": "Entertainment",
      "poi_address": "2801 E State Hwy 66, Elk City, OK 73644, USA",
      "poi_short_description": "Party venue offering pool, live music and DJ nights for dancing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-478b-711a-a4fb-755e4eea8f2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-478b-711a-a4fb-755e4eea8f2c",
        "storage_key": "property/6767906449166978/019d08b6-478b-711a-a4fb-755e4eea8f2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2651294369098368623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-twisted-mule-saloon",
      "poi_latitude": "35.4225828",
      "poi_longitude": "-99.371466",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-481-8258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7ac0-748d-872f-89286e19c4cd",
        "storage_key": "property/6767906449166978/019d08b6-7ac0-748d-872f-89286e19c4cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxz9gtdXkq4cRbwYaeS5KyyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_df751470-f59e-4fb3-a4c5-b9dd0bcd2779",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Great Plains Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-46c0-71c8-b394-c4d65afd41ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-46c0-71c8-b394-c4d65afd41ad",
        "storage_key": "property/6767906449166978/019d08b6-46c0-71c8-b394-c4d65afd41ad.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.gprmc-ok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1209569454627140351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-plains-regional-medical-center",
      "poi_latitude": "35.4138726",
      "poi_longitude": "-99.4262494",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-8093-76d4-8dbb-e2b167f3086c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-8093-76d4-8dbb-e2b167f3086c",
        "storage_key": "property/6767906449166978/019d08b6-8093-76d4-8dbb-e2b167f3086c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTck2AbPlq4cR_7I2qgJByRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fceb86d4-6ed8-4c95-b04a-4959d774b95d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Xpress Wellness Urgent Care - Elk City",
      "poi_type": "Health and Wellness",
      "poi_address": "411 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-49a3-712e-9079-efabc5750641.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-49a3-712e-9079-efabc5750641",
        "storage_key": "property/6767906449166978/019d08b6-49a3-712e-9079-efabc5750641.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://xpresswellnessurgentcare.com/locations/oklahoma/elk-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10768485197577272008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xpress-wellness-urgent-care---elk-city",
      "poi_latitude": "35.4120132",
      "poi_longitude": "-99.4095586",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-303-9293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6YcQKwHlq4cRyDqlujtYcZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_617f7d3b-0bcc-4950-927d-4c772d6fcbe7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "GPRMC Urgent Care Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "404 S Eastern Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-4cf6-76b0-b04c-202eeaf78f33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-4cf6-76b0-b04c-202eeaf78f33",
        "storage_key": "property/6767906449166978/019d08b6-4cf6-76b0-b04c-202eeaf78f33.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "https://gprmc-ok.com/urgent-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=157092626409201973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gprmc-urgent-care-clinic",
      "poi_latitude": "35.4066863",
      "poi_longitude": "-99.3806193",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-303-5890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxhWNiflq4cRNSH0UekaLgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_a8b662c0-0339-46bd-b618-340270494c3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "210 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-4dae-706e-bb16-01207fb18566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-4dae-706e-bb16-01207fb18566",
        "storage_key": "property/6767906449166978/019d08b6-4dae-706e-bb16-01207fb18566.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/134-elk-city-ok/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1115430163509384435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.4092259",
      "poi_longitude": "-99.3764982",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-1575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7460-70ce-8787-ebf0ba218c45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7460-70ce-8787-ebf0ba218c45",
        "storage_key": "property/6767906449166978/019d08b6-7460-70ce-8787-ebf0ba218c45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SeIX8zlq4cR85S769LNeg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_b01df5b5-06ff-4aca-9a38-1f8f12920e7a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "115 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-2411-768b-9b96-101dec929f47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2411-768b-9b96-101dec929f47",
        "storage_key": "property/6767906449166978/019d08b6-2411-768b-9b96-101dec929f47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-115+w+3rd+st-elk+city-ok-73644/id=9874",
      "poi_directions_map_url": "https://maps.google.com/?cid=17531138606873173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.4122316",
      "poi_longitude": "-99.4057989",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-4418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cX2CQTlq4cRVborSXpIPgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_55970594-0a77-4b4d-9e47-607c4baec58a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Paul Jones Drug",
      "poi_type": "Health and Wellness",
      "poi_address": "809 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-25d4-712a-97cd-c026b682c93f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-25d4-712a-97cd-c026b682c93f",
        "storage_key": "property/6767906449166978/019d08b6-25d4-712a-97cd-c026b682c93f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://pauljonesdrug.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13335305541602734711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-jones-drug",
      "poi_latitude": "35.4180854",
      "poi_longitude": "-99.4052474",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7460-70ce-8787-ebf0ba218c45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7460-70ce-8787-ebf0ba218c45",
        "storage_key": "property/6767906449166978/019d08b6-7460-70ce-8787-ebf0ba218c45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TL4FATlq4cRd3KHkryFELk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d6b5bce1-9fcf-4cf0-9329-c76fa01040ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "The Rig Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "408 S Jefferson St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-4de7-732f-a22e-2c61a6d5a95c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-4de7-732f-a22e-2c61a6d5a95c",
        "storage_key": "property/6767906449166978/019d08b6-4de7-732f-a22e-2c61a6d5a95c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6728145035199562682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rig-gym",
      "poi_latitude": "35.4070271",
      "poi_longitude": "-99.4060368",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-339-1787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYOLW_3lq4cRusNgJEMsX10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2aa2b73c-d04d-4a5d-a804-4dbb2ed91eda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Xtreme Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "N Beckham Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10103763496297258346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xtreme-fitness",
      "poi_latitude": "35.4111053",
      "poi_longitude": "-99.4229845",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTnLB7Llq4cRal1bK17HN4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e40b0ac8-3c97-45c7-b55b-a11762980efb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Velox Strength and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "504 W 20th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-4f65-71a9-bc37-e85a7870f261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-4f65-71a9-bc37-e85a7870f261",
        "storage_key": "property/6767906449166978/019d08b6-4f65-71a9-bc37-e85a7870f261.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18148594753891269525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "velox-strength-and-fitness",
      "poi_latitude": "35.3925047",
      "poi_longitude": "-99.4115028",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-303-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVUxD3Xlq4cRlfs09sXC3Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4455d1eb-a593-465b-82ff-e93d6ff081c2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "#1 Okie Design",
      "poi_type": "Health and Wellness",
      "poi_address": "116 W Broadway Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-5382-72da-a8ec-1fd6b29cd0a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-5382-72da-a8ec-1fd6b29cd0a1",
        "storage_key": "property/6767906449166978/019d08b6-5382-72da-a8ec-1fd6b29cd0a1.webp",
        "width": 1280,
        "height": 905
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1331841715366168815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1-okie-design",
      "poi_latitude": "35.4105601",
      "poi_longitude": "-99.4057374",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-243-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f53-737c-9c3f-da061bfd04bb",
        "storage_key": "property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwyN3FgTlq4cR74hy1fumexI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_f5e18b45-5107-4e53-a71d-78e89e81c161",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Ackley Park West",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-53fe-7377-b111-cd85209ae013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-53fe-7377-b111-cd85209ae013",
        "storage_key": "property/6767906449166978/019d08b6-53fe-7377-b111-cd85209ae013.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10164754160504351334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ackley-park-west",
      "poi_latitude": "35.4162111",
      "poi_longitude": "-99.4367361",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7a14-701c-b7d1-c6d9fc7b31e4",
        "storage_key": "property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJU7z08jvlq4cRZioJxg12EI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2d249fc6-8280-4860-a011-9d7cfb39e296",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Colonel Herring Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Colonel Herring Park, 321 W Country Club Blvd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18347049000009476931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonel-herring-park",
      "poi_latitude": "35.422215",
      "poi_longitude": "-99.40632560000002",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7a14-701c-b7d1-c6d9fc7b31e4",
        "storage_key": "property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKd73FQDlq4cRQytA0tvPnf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f91972be-c97c-42dc-a1d2-e20d60689749",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Rotary Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "417 McArthur Blvd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=638885698214575193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rotary-park",
      "poi_latitude": "35.4212041",
      "poi_longitude": "-99.4099537",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7a14-701c-b7d1-c6d9fc7b31e4",
        "storage_key": "property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22NzPgDlq4cRWTwoVijH3Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_380ae093-95f1-4ff7-846e-e6e86856d3fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Jaycee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Calhoon St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-53c7-733c-9336-f552769bc39a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-53c7-733c-9336-f552769bc39a",
        "storage_key": "property/6767906449166978/019d08b6-53c7-733c-9336-f552769bc39a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11644542863703076622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaycee-park",
      "poi_latitude": "35.4161673",
      "poi_longitude": "-99.3822243",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7a14-701c-b7d1-c6d9fc7b31e4",
        "storage_key": "property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxz5SYlPlq4cRDu_UAgq6maE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3dc5f778-c488-4c4e-a3ce-bf15f16efa92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Kiwanis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 W 9th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-56c9-727f-8924-dd45defd61f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-56c9-727f-8924-dd45defd61f6",
        "storage_key": "property/6767906449166978/019d08b6-56c9-727f-8924-dd45defd61f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2639815363630010691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "35.4058899",
      "poi_longitude": "-99.4202364",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7a14-701c-b7d1-c6d9fc7b31e4",
        "storage_key": "property/6767906449166978/019d08b6-7a14-701c-b7d1-c6d9fc7b31e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2K1Yejlq4cRQxHJPRaCoiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3f337916-5fa1-496f-b080-4346f212a22d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Lincoln Teen Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 S Franklin St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-5bab-715f-9665-352966eef69a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-5bab-715f-9665-352966eef69a",
        "storage_key": "property/6767906449166978/019d08b6-5bab-715f-9665-352966eef69a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8029301907884860347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-teen-center",
      "poi_latitude": "35.3982011",
      "poi_longitude": "-99.4104256",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-9025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl30tZArlq4cRu-PXTYvPbW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_460779c4-70e1-4d63-b4ab-253cf85d9749",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jct 6 & Hwy 66, 5100 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-5bab-715f-9665-322da8b4d379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-5bab-715f-9665-322da8b4d379",
        "storage_key": "property/6767906449166978/019d08b6-5bab-715f-9665-322da8b4d379.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-670186",
      "poi_directions_map_url": "https://maps.google.com/?cid=3449356901382581836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "35.4088418",
      "poi_longitude": "-99.4711706",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-8649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_d0sWPmq4cRTG5zitOT3i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9e5b8bc8-764d-4f35-ba12-4b85cbf964da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Phillips 66",
      "poi_type": "Transportation & Transit",
      "poi_address": "2001 E 7th St, Elk City, OK 73644, USA",
      "poi_short_description": "Chain gas station providing fuel, snacks, and drinks, plus a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6253-708c-b8ce-4df2d5ec5d49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-6253-708c-b8ce-4df2d5ec5d49",
        "storage_key": "property/6767906449166978/019d08b6-6253-708c-b8ce-4df2d5ec5d49.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://www.phillips66gas.com/station/66-HUTCHS-119-0000921157/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16558432508699617279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "35.407771",
      "poi_longitude": "-99.3801391",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-527-5476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-809b-707c-8909-4f73f700499f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-809b-707c-8909-4f73f700499f",
        "storage_key": "property/6767906449166978/019d08b6-809b-707c-8909-4f73f700499f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzkB9rPlq4cR_ydS5qJey-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_4594b9a9-2f3f-4d0a-94ae-d47e8316a9d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Motel 6 Elk City, OK",
      "poi_type": "Transportation & Transit",
      "poi_address": "2604 U.S. Rte 66, Elk City, OK 73644, USA",
      "poi_short_description": "Unpretentious budget property offering free WiFi, morning coffee & truck parking.",
      "poi_long_description": "Unpretentious budget property offering free WiFi, morning coffee & truck parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6253-708c-b8ce-5228a74809da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-6253-708c-b8ce-5228a74809da",
        "storage_key": "property/6767906449166978/019d08b6-6253-708c-b8ce-5228a74809da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.motel6.com/property/motel-elk-city-ok-oklahoma-us-293239?lid=Local_Milestone&travelAgentNumber=TA001305&corporatePlusNumber=CP792N5W&utm_source=google%20my%20business&utm_medium=organic%20listing&utm_campaign=visit%20website&utm_content=global",
      "poi_directions_map_url": "https://maps.google.com/?cid=15188549443857462856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "motel-6-elk-city-ok",
      "poi_latitude": "35.4213142",
      "poi_longitude": "-99.3748092",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-2541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-8120-7323-bda3-fcf83c684dd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-8120-7323-bda3-fcf83c684dd9",
        "storage_key": "property/6767906449166978/019d08b6-8120-7323-bda3-fcf83c684dd9.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJd40MRtbkq4cRSLaULj-RyNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "motel"
    },
    {
      "id": "custom_e9b6782b-7c47-4d89-a49b-9aa4ca1d73dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Love's Travel Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "2703 U.S. Rte 66, Elk City, OK 73644, USA",
      "poi_short_description": "Chain truck stop offering fuel, snacks, and other travel necessities, plus clean restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-5e7d-778e-a972-2ebe6543e630.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-5e7d-778e-a972-2ebe6543e630",
        "storage_key": "property/6767906449166978/019d08b6-5e7d-778e-a972-2ebe6543e630.webp",
        "width": 609,
        "height": 368
      },
      "poi_business_url": "https://www.loves.com/locations/201",
      "poi_directions_map_url": "https://maps.google.com/?cid=2426491255109843683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loves-travel-stop",
      "poi_latitude": "35.4229483",
      "poi_longitude": "-99.3723378",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-9162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f53-737c-9c3f-da061bfd04bb",
        "storage_key": "property/6767906449166978/019d08b6-6f53-737c-9c3f-da061bfd04bb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcSNIRdbkq4cR4_ppv_CgrCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_24b8612b-ae33-4355-b6d9-e3fb4419e7d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Clinton Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "10200 Airport Rd, Clinton, OK 73601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6312-7502-b5dc-dcbcfb93d81c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-6312-7502-b5dc-dcbcfb93d81c",
        "storage_key": "property/6767906449166978/019d08b6-6312-7502-b5dc-dcbcfb93d81c.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7677089660396348517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clinton-regional-airport",
      "poi_latitude": "35.5386848",
      "poi_longitude": "-98.9363861",
      "poi_miles_from_property": "33.9",
      "poi_walking_minutes": "12 hours 10 mins",
      "poi_biking_minutes": "2 hours 45 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 580-323-5782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-808b-711e-b410-23c98cd7d93f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-808b-711e-b410-23c98cd7d93f",
        "storage_key": "property/6767906449166978/019d08b6-808b-711e-b410-23c98cd7d93f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb-BeC0crIcRZaS_BF-Aimo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e522ee27-c420-4cde-9299-112919ae3be4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Bar-S Foods Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Bar-S Drive, Elk City, OK 73644, USA",
      "poi_short_description": "Warehouse distributing meat products, with some reviews highlighting the helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6502-729e-bf44-f40e56350112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-6502-729e-bf44-f40e56350112",
        "storage_key": "property/6767906449166978/019d08b6-6502-729e-bf44-f40e56350112.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bar-s.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8796228948143088854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bar-s-foods-co",
      "poi_latitude": "35.4056235",
      "poi_longitude": "-99.3876028",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-821-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUxPLj3lq4cR1qQTuZ97Eno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_5ecc27bf-e62b-4beb-8d88-408b9c3fea62",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Bronco Oilfield Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4001 W 7th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.broncoservices.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10869321672113553961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bronco-oilfield-services",
      "poi_latitude": "35.4077663",
      "poi_longitude": "-99.4593265",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-9168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-6f39-773f-ae07-accd5f61870a",
        "storage_key": "property/6767906449166978/019d08b6-6f39-773f-ae07-accd5f61870a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzndznflq4cRKYLI_3iW15Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5f8fc608-f507-406b-8734-e560bdad5c4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "320 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6817-721c-9ca1-697d438e4cc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-6817-721c-9ca1-697d438e4cc6",
        "storage_key": "property/6767906449166978/019d08b6-6817-721c-9ca1-697d438e4cc6.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.elkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12163949303985423824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-city-hall",
      "poi_latitude": "35.4110298",
      "poi_longitude": "-99.4081802",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-86d9-7658-88a1-9c6b39293f7a",
        "storage_key": "property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQb4nwblq4cR0EXp0XEHz6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_33375565-5210-44b8-8b3c-b76d40f0d453",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Schools Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Boone Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523048044287010810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-schools-administration",
      "poi_latitude": "35.414287",
      "poi_longitude": "-99.4123481",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-0175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-7508-77c2-a077-5bae828afa80",
        "storage_key": "property/6767906449166978/019d08b6-7508-77c2-a077-5bae828afa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVqboQblq4cR-qcw0Gw9Qgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_065788c1-49cb-4684-9464-f3585f60c137",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "422 E 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://elkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15693535911759071102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-police-department",
      "poi_latitude": "35.4112308",
      "poi_longitude": "-99.4000507",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-86d9-7658-88a1-9c6b39293f7a",
        "storage_key": "property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSunSBvlq4cRfkc8isOjytk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_fbeb5273-3a95-4060-ac0b-64c201cf1f2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Fire Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "403 W 5th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-6872-7179-ba2a-52545848a6cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-6872-7179-ba2a-52545848a6cb",
        "storage_key": "property/6767906449166978/019d08b6-6872-7179-ba2a-52545848a6cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/fire-department/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16223492038763388143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-fire-department",
      "poi_latitude": "35.409867",
      "poi_longitude": "-99.408651",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-86d9-7658-88a1-9c6b39293f7a",
        "storage_key": "property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx01ajQblq4cR75zesg1sJeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fire_station"
    },
    {
      "id": "custom_a6aff3b6-8613-43f7-ac8b-bf23c87dafea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101 S Adams Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Post office offering standard mailing and shipping services, as well as money orders.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-69a0-7479-89ab-0095bcac7401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-69a0-7479-89ab-0095bcac7401",
        "storage_key": "property/6767906449166978/019d08b6-69a0-7479-89ab-0095bcac7401.webp",
        "width": 720,
        "height": 730
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1362299?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16434881858389135973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "35.4102346",
      "poi_longitude": "-99.4078857",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-86d9-7658-88a1-9c6b39293f7a",
        "storage_key": "property/6767906449166978/019d08b6-86d9-7658-88a1-9c6b39293f7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTech6gblq4cRZdLLdvltFOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    },
    {
      "id": "custom_efc771e0-5e98-4c0b-a915-2afe8e6a64f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "custom",
      "poi_name": "Elk City Municipal Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101 Norman Martin Blvd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-5bdb-712e-a8fa-3c095dd1ef68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-5bdb-712e-a8fa-3c095dd1ef68",
        "storage_key": "property/6767906449166978/019d08b6-5bdb-712e-a8fa-3c095dd1ef68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6815549716414817956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-municipal-airport",
      "poi_latitude": "35.425976",
      "poi_longitude": "-99.3958509",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166978/019d08b6-808b-711e-b410-23c98cd7d93f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-808b-711e-b410-23c98cd7d93f",
        "storage_key": "property/6767906449166978/019d08b6-808b-711e-b410-23c98cd7d93f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyhJguDlq4cRpGbrU1uylV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    }
  ],
  "office_hours": [
    {
      "id": "custom_22d41099-3c78-499f-8ee5-a0de5849a3b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_6aec6de9-75e3-42da-be64-b6713d1a1ffb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_36ddb16e-e922-42a6-b43d-18841bebacd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_64ab6c89-e7dd-4a0b-8744-433805c3f52d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_796b86c6-b331-4e45-aad2-e20d7e5f179d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_200cbd8b-91ec-4a8a-8988-9863b740beed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "14:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_035d6b57-fd6b-45e2-8540-807c2c843c9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "rating": "4",
      "name": "Brent Wheeler",
      "text": "It was good , everything is good. Ty",
      "date": "2025-12-19",
      "title": "false"
    },
    {
      "id": "custom_f61602ca-b934-466d-9728-4c6a5ae047ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "rating": "5",
      "name": "Dontae Elix",
      "text": "Great experience, respectful and ready to get us moved in asap! Love the service",
      "date": "2025-12-05",
      "title": "false"
    },
    {
      "id": "custom_495c952f-0b7c-4dfd-a012-0039cbd89ba2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "rating": "4",
      "name": "Rick",
      "text": "My wife and I are really loving our apartment. We really haven't had any problems and if something does ever happen they are quick to fix the concern. The manager and the maintenance is very friendly and helpful. Our apartment is well kept and spacious. We would highly recommend park 220 to other people looking for a nice place to stay.",
      "date": "2025-12-19",
      "title": "false"
    },
    {
      "id": "custom_067bc2d2-c0b9-49a6-89ac-27eb5a195749",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "rating": "4",
      "name": "Kristin Higgins",
      "text": "They were quick to handle both issues I had, one within the same day I had made a request! Nick and TaTionna in the office are very helpful and really friendly! I love it here, it's a nice place to call home!",
      "date": "2025-04-08",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ba371-d495-732d-9c8e-252d9fa4703a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-park-220",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978"
    },
    {
      "lead_collector_id": "019ba50d-2dad-7446-a028-251f9626e7bd",
      "lead_source": "LANDING_PAGE",
      "name": "park-220-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-elk-city-ok",
      "search_query": "smoke-free apartments Elk City OK",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Elk City, OK",
      "h2_subtitle": "Discover smoke-free living at Park 220. Enjoy clean, fresh air in our Elk City, OK, apartments for a healthier lifestyle.",
      "page_copy": "Welcome to Park 220, where smoke-free apartments in Elk City, OK, offer a serene and healthy living environment. Our community is dedicated to providing residents with a clean and fresh atmosphere. Enjoy stylish studio to spacious three-bedroom floor plans that cater to all lifestyles, complete with modern amenities and energy-efficient appliances.\n\nLocated in the inviting Oklahoma West Area, Park 220 features a seasonal pool, covered parking, and a newly remodeled laundry room, ensuring convenience and comfort. Experience the peace of mind that comes with living in a smoke-free community and create an environment that promotes wellness. Find your new home today at Park 220 and embrace a healthier way of living in Elk City, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in Elk City, OK",
      "seo_description": "Enjoy smoke-free living at Park 220 in Elk City, OK. Discover our modern and healthy apartments today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "apartments-with-pool-beckham-county",
      "search_query": "apartments with pool in Beckham County",
      "category": "Amenity",
      "h1_title": "Beckham County Apartments with Pool",
      "h2_subtitle": "Dive into relaxation at Park 220, offering top-notch apartments with a pool in Beckham County. Enjoy seasonal pool access at our Elk City location.",
      "page_copy": "Park 220 invites you to explore our premier apartments with pool access in the heart of Beckham County. Designed with relaxation in mind, our seasonal pool area provides the perfect setting to unwind and soak up the sun. Whether lounging poolside or taking a refreshing dip, it's just one of the many perks of living at Park 220.\n\nConveniently located in Elk City, OK, our community offers a range of floor plans from studios to three-bedroom homes, all outfitted with modern finishes and energy-efficient appliances. With additional amenities like a newly remodeled laundry room and covered parking, Park 220 strives to meet every resident's needs. Experience the benefits of poolside living in Beckham County at Park 220 today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Beckham County Apartments with Pool",
      "seo_description": "Find your home at Park 220 with a pool in Beckham County, Elk City. Enjoy modern amenities and seasonal pool access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "covered-parking-apartments-oklahoma-west-area",
      "search_query": "covered parking apartments Oklahoma West Area",
      "category": "Amenity",
      "h1_title": "Covered Parking Apartments in Oklahoma West Area",
      "h2_subtitle": "Experience convenience with covered parking at Park 220 in the Oklahoma West Area. Protect your vehicle and enjoy stress-free living.",
      "page_copy": "Discover the convenience of covered parking at Park 220, located in the desirable Oklahoma West Area. Our apartments not only provide a stylish and comfortable living space but also come with the added benefit of covered parking. This amenity ensures that your vehicle is shielded from the elements, offering protection and peace of mind all year round.\n\nPark 220 offers a range of floor plans from cozy studios to spacious three-bedroom homes, all featuring modern finishes and energy-efficient appliances. Situated in Elk City, OK, this community also boasts amenities such as a seasonal pool, a newly remodeled laundry room, and smoke-free living. Enjoy a hassle-free lifestyle with the convenience of covered parking and more at Park 220.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Covered Parking Apartments in Oklahoma West Area",
      "seo_description": "Enjoy covered parking at Park 220 in the Oklahoma West Area, Elk City, OK. Modern apartments with stress-free amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-elk-city-73644",
      "search_query": "energy-efficient apartments Elk City 73644",
      "category": "Amenity",
      "h1_title": "Energy-Efficient Apartments in Elk City 73644",
      "h2_subtitle": "Discover energy-efficient living at Park 220 in Elk City 73644. Our modern apartments offer eco-friendly amenities for a sustainable lifestyle.",
      "page_copy": "Park 220 is proud to offer energy-efficient apartments in Elk City, 73644, designed to provide a sustainable and cost-effective lifestyle. Each residence features state-of-the-art, energy-efficient appliances, including A/C & heat, microwaves, refrigerators, and dishwashers. These modern additions not only reduce your carbon footprint but also ensure lower utility bills.\n\nLocated in the vibrant Oklahoma West Area, Park 220 provides residents with stylish living spaces ranging from studios to three-bedroom homes. Beyond the eco-friendly features, our community boasts additional amenities like a seasonal pool, smoke-free environment, and covered parking. Embrace a greener way of life at Park 220, where comfort meets sustainability in Elk City, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy-Efficient Apartments in Elk City 73644",
      "seo_description": "Find energy-efficient apartments at Park 220 in Elk City 73644. Enjoy modern, eco-friendly amenities in a sustainable community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-hookup-elk-city",
      "search_query": "in-unit washer dryer hookup Elk City",
      "category": "Amenity",
      "h1_title": "In-Unit Washer Dryer Hookup in Elk City",
      "h2_subtitle": "Find the convenience of in-unit washer dryer hookup at Park 220 in Elk City. Enjoy a modern lifestyle with in-home laundry capabilities.",
      "page_copy": "At Park 220 in Elk City, we understand the importance of convenient living, which is why select apartments offer in-unit washer dryer hookups. This valued feature allows residents to enjoy the ease and comfort of doing laundry from the privacy of their own homes, eliminating the hassle of communal laundry spaces.\n\nOur community offers a range of floor plan options, from studios to three-bedroom units, all designed with modern finishes and energy-efficient amenities. Located in the Oklahoma West Area, Park 220 provides residents with a smoke-free environment, covered parking, and a refreshing seasonal pool. Experience the blend of convenience and style in Elk City with in-unit washer dryer hookups and more at Park 220.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Hookup in Elk City",
      "seo_description": "Experience in-unit washer dryer hookups at Park 220 in Elk City. Enjoy modern living with private laundry capabilities and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "studio-apartments-elk-city-ok",
      "search_query": "studio apartments elk city ok",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Elk City, OK",
      "h2_subtitle": "Explore modern studio apartments at Park 220 in Elk City, OK. Perfectly designed for comfort and style in the Oklahoma West Area.",
      "page_copy": "Discover the ideal living space with the stylish studio apartments at Park 220 in Elk City, OK. Our studios are thoughtfully designed to maximize space and functionality, featuring contemporary finishes and energy-efficient amenities. These efficient homes are perfect for individuals seeking a modern lifestyle without the extra space of larger units.\n\nLocated in the vibrant Oklahoma West Area, Park 220 offers more than just stylish studios. Residents can enjoy the benefits of a seasonal pool, covered parking, and a smoke-free environment. Whether you're new to the area or looking to downsize, our community provides a comfortable and convenient living experience. Join the Park 220 community in Elk City and enjoy the simplicity and charm of studio living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Elk City, OK",
      "seo_description": "Find stylish studio apartments at Park 220 in Elk City, OK. Modern living with energy-efficient amenities in the Oklahoma West Area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-beckham-county",
      "search_query": "one bedroom apartments beckham county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Beckham County",
      "h2_subtitle": "Discover comfortable one bedroom apartments at Park 220 in Beckham County. Enjoy modern amenities and a welcoming community atmosphere in Elk City.",
      "page_copy": "Park 220 offers charming one bedroom apartments nestled in the heart of Beckham County. Our thoughtfully designed spaces deliver modern comfort with features such as energy-efficient appliances, including microwaves and refrigerators, alongside stylish finishes that cater to all your living needs. Ideal for singles or couples, these apartments provide the perfect blend of coziness and functionality.\n\nSituated in Elk City's Oklahoma West Area, Park 220 is a community that values convenience and quality of life. Residents benefit from covered parking, a seasonal swimming pool, and a smoke-free environment. These one bedroom apartments offer more than just a place to live—they provide a welcoming community experience in Beckham County. Choose Park 220 for a lifestyle that emphasizes comfort and modernity.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Beckham County",
      "seo_description": "Explore one bedroom apartments at Park 220 in Beckham County, offering modern amenities and a spacious layout in a welcoming Elk City community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-73644",
      "search_query": "two bedroom apartments near 73644",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 73644",
      "h2_subtitle": "Check out spacious two bedroom apartments at Park 220 near the 73644 ZIP code. Enjoy modern amenities in Elk City, OK.",
      "page_copy": "Searching for the perfect two bedroom apartment near the 73644 area? Look no further than Park 220 in Elk City, where comfort meets modern design. Our two bedroom units offer ample space, featuring contemporary finishes and energy-efficient appliances. These thoughtfully crafted homes provide the ideal setting for families or roommates looking to share a functional and stylish living environment.\n\nPark 220 is more than just a place to call home; it's a community that fosters convenience and quality. Located in the Oklahoma West Area, residents enjoy amenities such as covered parking, a seasonal pool, and a welcoming, smoke-free atmosphere. Make Park 220 your new home and relish the comfort and accessibility of our two bedroom apartments, perfectly suited for life near the 73644 ZIP code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 73644",
      "seo_description": "Discover two bedroom apartments at Park 220 near 73644 in Elk City, OK. Enjoy spacious living with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-oklahoma-west-area",
      "search_query": "three bedroom apartments oklahoma west area",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Oklahoma West",
      "h2_subtitle": "Explore spacious three bedroom apartments at Park 220, ideally located in the Oklahoma West Area. Perfect for families or roommates.",
      "page_copy": "For families or roommates seeking room to grow, the three bedroom apartments at Park 220 in the Oklahoma West Area present the perfect solution. Our expansive layouts offer plenty of space for comfort and privacy, complemented by modern finishes and energy-efficient amenities like refrigerators, dishwashers, and lighting. These beautifully appointed homes create an ideal setting for managing busy lifestyles or simply enjoying downtime together.\n\nBeyond the spacious interiors, Park 220 offers a rich community experience in Elk City. Residents enjoy benefits such as covered parking, access to a seasonal pool, and a smoke-free environment creating a desirable living atmosphere. Discover how our three bedroom apartments stand out in the Oklahoma West Area as the perfect choice for your next home adventure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Oklahoma West",
      "seo_description": "Find spacious three bedroom apartments at Park 220 in Oklahoma West Area. Perfect for families or roommates looking for modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "apartments-near-elk-city-elementary-school-ok",
      "search_query": "apartments near Elk City Elementary School OK",
      "category": "School",
      "h1_title": "Apartments Near Elk City Elementary School",
      "h2_subtitle": "Discover family-friendly apartments near Elk City Elementary School at Park 220. Enjoy modern amenities in a convenient location in Elk City, OK.",
      "page_copy": "Looking for a convenient location near Elk City Elementary School? Park 220 offers beautifully designed apartments perfect for families. Our community is situated in Elk City, providing easy access to local schools while offering the ideal living environment. Choose from a variety of floor plans, including studio, one, two, and three bedroom options, all equipped with energy-efficient appliances and modern amenities.\n\nResidents of Park 220 benefit from a welcoming environment that emphasizes comfort and ease. Enjoy covered parking, a seasonal pool, and a smoke-free setting—creating a perfect place for families. Our location in the Oklahoma West Area ensures you are close to essential conveniences and educational opportunities. Discover how Park 220 apartments can meet your family’s needs near Elk City Elementary School.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Elk City Elementary School",
      "seo_description": "Explore family-friendly apartments at Park 220, conveniently located near Elk City Elementary School in Elk City, OK. Perfect for comfortable, modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "elk-city-intermediate-school-nearby-apartments",
      "search_query": "Elk City Intermediate School nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Elk City Intermediate School",
      "h2_subtitle": "Find conveniently located apartments near Elk City Intermediate School at Park 220. Ideal for families in the heart of Elk City, OK.",
      "page_copy": "If you're seeking a home near educational facilities, Park 220 offers the perfect solution with its close proximity to Elk City Intermediate School. Our community presents a selection of stylish apartments ranging from studios to spacious three-bedroom layouts, all enhanced with modern finishes and energy-efficient features—ideal for families prioritizing quality education in the neighborhood.\n\nPark 220 is nestled in the Oklahoma West Area, offering families the convenience of being minutes away from Elk City Intermediate School, making school commutes simple and efficient. Beyond the core offerings, residents enjoy amenities such as a seasonal pool, smoke-free living, and the assurance of on-site maintenance. Explore how Park 220 can be the perfect fit for anyone looking for nearby apartments with access to educational excellence.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Elk City Intermediate School",
      "seo_description": "Discover convenient living at Park 220, close to Elk City Intermediate School in Elk City, OK. Offering modern apartments ideal for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "elk-city-middle-school-rentals-elk-city",
      "search_query": "Elk City Middle School rentals Elk City",
      "category": "School",
      "h1_title": "Rentals Near Elk City Middle School",
      "h2_subtitle": "Explore desirable rentals near Elk City Middle School at Park 220, offering a community-focused environment right in Elk City.",
      "page_copy": "Park 220 is the ideal place for families looking for rentals near Elk City Middle School. Located in the heart of Elk City, our rentals provide convenience and comfort with options ranging from studios to three-bedroom apartments. Every unit features energy-efficient appliances to suit your busy lifestyle, adding modern touches that define contemporary living.\n\nFamilies will enjoy the benefits of living at Park 220, including easy access to Elk City Middle School, making daily commutes swift and simple. The community provides excellent amenities such as a seasonal pool, covered parking, and a smoke-free environment, ensuring a well-rounded and enriching living experience. Explore Park 220, where educational proximity meets community comfort in Elk City.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Elk City Middle School",
      "seo_description": "Find comfortable rentals near Elk City Middle School at Park 220 in Elk City, OK. Offering modern apartment features and convenient school access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "apartments-close-to-elk-city-high-school-73644",
      "search_query": "apartments close to Elk City High School 73644",
      "category": "School",
      "h1_title": "Apartments Close to Elk City High School",
      "h2_subtitle": "Discover convenient living in Elk City's 73644 area with apartments close to Elk City High School at Park 220.",
      "page_copy": "For those looking for apartments close to Elk City High School, Park 220 offers a superb location in the 73644 area. Our community caters to diverse lifestyles by offering a range of floor plans from cozy studios to spacious three-bedroom apartments. Each unit is designed with modern amenities and energy-efficient appliances, ensuring a comfortable living environment for you and your family.\n\nSituated in the Oklahoma West Area, Park 220 provides easy access to Elk City High School, making it perfect for families with teenagers. Enjoy community amenities such as a seasonal pool and an on-site maintenance team, alongside the peace of mind of a smoke-free atmosphere. Experience the convenience of living near Elk City High School, coupled with the welcoming community and modern comfort of Park 220.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Elk City High School",
      "seo_description": "Live near Elk City High School in the 73644 area at Park 220. Explore modern apartment options in a prime location perfect for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "fairview-elementary-school-apartments-oklahoma-west-area",
      "search_query": "Fairview Elementary School apartments Oklahoma West Area",
      "category": "School",
      "h1_title": "Apartments Near Fairview Elementary School",
      "h2_subtitle": "Locate family-friendly apartments near Fairview Elementary School in the Oklahoma West Area at Park 220.",
      "page_copy": "Park 220 is the perfect choice for families seeking apartments near Fairview Elementary School in the Oklahoma West Area. Our community offers a variety of floor plans, including studios and three-bedroom units, all equipped with modern finishes and energy-efficient appliances that cater to today's lifestyles. Families will find the proximity to Fairview Elementary School incredibly convenient, contributing to a streamlined daily routine.\n\nIn addition to its prime location, Park 220 boasts desirable amenities such as a refreshing seasonal pool, efficient on-site maintenance, and a smoke-free environment, providing a well-rounded and enjoyable living experience. Enjoy the benefits of living in the Oklahoma West Area at Park 220, where education and comfort meet seamlessly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fairview Elementary School",
      "seo_description": "Explore family-friendly living near Fairview Elementary School at Park 220 in Oklahoma West Area. Modern living with school convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "apartments-near-great-plains-regional-medical-center-elk-city",
      "search_query": "apartments near great plains regional medical center elk city",
      "category": "Hospital",
      "h1_title": "Apartments Near Great Plains Medical Center",
      "h2_subtitle": "Discover comfort and convenience with apartments near Great Plains Regional Medical Center in Elk City at Park 220.",
      "page_copy": "Park 220 offers an ideal living location for those seeking apartments near Great Plains Regional Medical Center in Elk City. Situated in a prime area, our community provides easy access to the medical center, making it perfect for healthcare professionals and patients looking for proximity and convenience. Our apartments range from studio to three-bedroom layouts, each featuring modern designs and energy-efficient amenities, ensuring a comfortable living experience.\n\nResidents at Park 220 benefit from an array of community amenities such as a seasonal swimming pool, covered parking, and a newly remodeled laundry room. This smoke-free community also provides on-site maintenance, fostering a hassle-free living environment. Experience the balance of work and relaxation by choosing Park 220, where you can live close to the Great Plains Regional Medical Center without compromising on luxury or convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Great Plains Medical Center",
      "seo_description": "Live conveniently near Great Plains Regional Medical Center at Park 220 in Elk City. Enjoy modern amenities and ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "apartments-near-ackley-park-elk-city",
      "search_query": "apartments near Ackley Park Elk City",
      "category": "Park",
      "h1_title": "Apartments Near Ackley Park, Elk City",
      "h2_subtitle": "Find your dream home at Park 220, offering stylish apartments just a short stroll from Ackley Park in Elk City.",
      "page_copy": "If you're looking for apartments near Ackley Park, Elk City, Park 220 is your ideal choice. Situated in a convenient location close to this favorite local landmark, our community offers a plethora of floor plans ranging from cozy studios to spacious three bedrooms. These thoughtfully designed units come equipped with contemporary finishes and energy-saving appliances, perfect for those who value style and efficiency.\n\nLiving at Park 220 means you're not only steps away from the natural beauty and recreational opportunities of Ackley Park but also benefit from our community's superior amenities. Enjoy a refreshing swim in the seasonal pool, experience hassle-free living with our on-site maintenance, and embrace a healthy lifestyle in our smoke-free environment. Our welcoming community captures the essence of Elk City's charm while providing a peaceful and comfortable living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ackley Park, Elk City",
      "seo_description": "Experience convenient living near Ackley Park at Park 220. Modern apartments with top amenities close to Elk City's recreational hub.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "apartments-close-to-ackley-park-west-ok",
      "search_query": "apartments close to Ackley Park West OK",
      "category": "Park",
      "h1_title": "Apartments Close to Ackley Park West",
      "h2_subtitle": "Discover comfortable living at Park 220, offering apartments close to Ackley Park West in Elk City, OK.",
      "page_copy": "Searching for apartments close to Ackley Park West? Park 220 offers an outstanding living experience in Elk City, OK, with its prime location near this popular park. Choose from a selection of finely crafted floor plans, from efficient studios to expansive three-bedroom apartments, all featuring modern finishes and energy-efficient amenities that enhance your lifestyle.\n\nA short distance from Ackley Park West, Park 220 provides a perfect blend of nature and convenience. Residents can enjoy the tranquil environment while also taking advantage of community features such as a seasonal swimming pool, on-site maintenance services, and a smoke-free atmosphere. Whether you're relaxing at home or exploring Elk City's attractions, Park 220 places you in the heart of everything you need.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ackley Park West, Elk City",
      "seo_description": "Live near Ackley Park West in Elk City with modern apartments at Park 220. Perfect for nature lovers and comfort seekers alike.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "rentals-by-colonel-herring-park-beckham-county",
      "search_query": "rentals by Colonel Herring Park Beckham County",
      "category": "Park",
      "h1_title": "Rentals by Colonel Herring Park, Beckham County",
      "h2_subtitle": "Explore Park 220 in Elk City, offering rentals conveniently situated by Colonel Herring Park, Beckham County.",
      "page_copy": "Park 220 presents exceptional rentals conveniently located by Colonel Herring Park in Beckham County. Nestled in Elk City, our community provides easy access to this beloved park, offering residents the opportunity to enjoy local recreational activities easily. Choose from a wide range of stylish studio, one, two, and three-bedroom apartments, each designed with modern finishes and high-efficiency appliances.\n\nLiving at Park 220 means embracing both comfort and community. Our rentals offer an array of amenities such as a seasonal swimming pool, smoke-free environment, and reliable on-site maintenance. With close proximity to Colonel Herring Park, residents can enjoy serene outdoor spaces while benefiting from the conveniences of Elk City's vibrant community. Make Park 220 your new home and experience the perfect blend of location and lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Colonel Herring Park, Elk City",
      "seo_description": "Park 220 offers rentals near Colonel Herring Park in Elk City, Beckham County. Enjoy modern living and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "apartments-around-rotary-park-elk-city",
      "search_query": "apartments around Rotary Park Elk City",
      "category": "Park",
      "h1_title": "Apartments Around Rotary Park, Elk City",
      "h2_subtitle": "Discover Park 220, featuring stylish apartments around Rotary Park in Elk City, offering convenience and luxury.",
      "page_copy": "Are you on the hunt for apartments around Rotary Park, Elk City? Look no further than Park 220, where prime location meets modern living. Our community offers a variety of floor plans ranging from cozy studios to expansive three-bedroom units, all crafted with contemporary finishes and energy-efficient amenities that cater to your lifestyle needs.\n\nLocated just minutes from Rotary Park, Park 220 allows you to enjoy the lush green spaces and recreational opportunities that Elk City has to offer. Dive into the welcoming community amenities including a seasonal pool, hassle-free on-site maintenance, and a smoke-free living environment. By choosing Park 220, you’re not just finding an apartment, but a vibrant community close to everything Elk City has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Around Rotary Park, Elk City",
      "seo_description": "Park 220 offers stylish apartments around Rotary Park in Elk City. Enjoy convenience and modern amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "properties-near-jaycee-park-oklahoma-west-area",
      "search_query": "properties near Jaycee Park Oklahoma West Area",
      "category": "Park",
      "h1_title": "Properties Near Jaycee Park, Oklahoma West Area",
      "h2_subtitle": "Explore Park 220, offering quality properties near Jaycee Park in the Oklahoma West Area.",
      "page_copy": "Looking for properties near Jaycee Park in the Oklahoma West Area? Discover Park 220, where modern living meets a prime location. Our diverse floor plans range from studios to three-bedroom apartments, each thoughtfully designed with contemporary finishes and energy-efficient appliances to complement your lifestyle.\n\nSituated conveniently close to Jaycee Park, Park 220 provides easy access to outdoor activities and community gatherings in Elk City. Residents can enjoy a host of amenities, including a refreshing seasonal pool and attentive on-site maintenance, all within a smoke-free environment. Experience the perfect mix of comfort and convenience at Park 220, where you're just moments away from all that the Oklahoma West Area has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Properties Near Jaycee Park, Oklahoma West Area",
      "seo_description": "Park 220 offers modern properties near Jaycee Park in Elk City's Oklahoma West Area. Enjoy comfortable living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166978",
      "source": "generator",
      "page_item_url": "housing-close-to-kiwanis-park-73644",
      "search_query": "housing close to Kiwanis Park 73644",
      "category": "Park",
      "h1_title": "Housing Close to Kiwanis Park, 73644",
      "h2_subtitle": "Discover Park 220, offering stylish housing close to Kiwanis Park in Elk City's 73644 area.",
      "page_copy": "Searching for housing close to Kiwanis Park, 73644? Park 220 is your ideal destination for quality living in Elk City. Offering a range of apartments from studios to three-bedrooms, each unit is equipped with modern finishes and energy-efficient features, ensuring a comfortable and sustainable home environment.\n\nPark 220 is perfectly situated just a short distance from Kiwanis Park, allowing residents easy access to one of Elk City's favorite green spaces. Our community is enriched with amenities including a seasonal swimming pool, reliable on-site maintenance, and a smoke-free policy, all designed to enhance your living experience. Embrace the benefits of living at Park 220, where convenience meets a vibrant community near Kiwanis Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Close to Kiwanis Park, Elk City",
      "seo_description": "Park 220 offers stylish housing close to Kiwanis Park in Elk City, 73644, featuring modern amenities and convenient access to green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5826"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10636247213"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5599111"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MC4BB9P5"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_fr_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=fr"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "580-563-0397"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_fr_title",
      "type": "STRING",
      "value": "ForRent"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "580-268-7610"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "580-681-1050"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "580-313-7381"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "580-260-3061"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "580-217-3802"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "580-875-8163"
    },
    {
      "ID": "custom_knock_fr_number",
      "type": "STRING",
      "value": "580-246-5699"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "580-751-2788"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "580-258-7362"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "580-875-8061"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "580-403-5824"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "580-260-3192"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "580-217-2298"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "580-954-0936"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "45778902284"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "580-670-8537"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "580-203-0676"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e11f03866d3acfe0"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "580-217-8889"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "580-997-4809"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "580-232-8629"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "580-808-3617"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "580-952-1172"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "580-722-4208"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.park220apts.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "580-268-7092"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "580-751-2788"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5826",
  "custom_repli_id": "10636247213",
  "custom_realpage_id": "5599111",
  "custom_knock_a_link": "https://www.park220apts.com?utm_knock=a",
  "custom_knock_g_link": "https://www.park220apts.com?utm_knock=g",
  "custom_knock_r_link": "https://www.park220apts.com?utm_knock=r",
  "custom_knock_w_link": "https://www.park220apts.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-MC4BB9P5",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_cl_link": "https://www.park220apts.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.park220apts.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.park220apts.com?utm_knock=fl",
  "custom_knock_fr_link": "https://www.park220apts.com?utm_knock=fr",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.park220apts.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "580-563-0397",
  "custom_knock_ads_link": "https://www.park220apts.com?utm_knock=ads",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_fr_title": "ForRent",
  "custom_knock_g_number": "580-268-7610",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.park220apts.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.park220apts.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.park220apts.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.park220apts.com?utm_knock=psa",
  "custom_knock_r_number": "580-681-1050",
  "custom_knock_w_number": "580-313-7381",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_cl_number": "580-260-3061",
  "custom_knock_fb_number": "580-217-3802",
  "custom_knock_fl_number": "580-875-8163",
  "custom_knock_fr_number": "580-246-5699",
  "custom_knock_gp_number": "580-751-2788",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.park220apts.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "580-258-7362",
  "custom_knock_bcard_link": "https://www.park220apts.com?utm_knock=bcard",
  "custom_knock_cfres_link": "https://www.park220apts.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "580-875-8061",
  "custom_knock_lgp_number": "580-403-5824",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.park220apts.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "580-260-3192",
  "custom_knock_psa_number": "580-217-2298",
  "custom_seo_subscription": "essential",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.park220apts.com?utm_knock=flyers",
  "custom_knock_osoc_number": "580-954-0936",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "45778902284",
  "custom_knock_bcard_number": "580-670-8537",
  "custom_knock_cfres_number": "580-203-0676",
  "custom_knock_chatgpt_link": "https://www.park220apts.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "e11f03866d3acfe0",
  "custom_knock_dirmail_link": "https://www.park220apts.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "580-217-8889",
  "custom_knock_propbro_link": "https://www.park220apts.com?utm_knock=propbro",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "580-997-4809",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.park220apts.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "580-232-8629",
  "custom_knock_dirmail_number": "580-808-3617",
  "custom_knock_propbro_number": "580-952-1172",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "580-722-4208",
  "custom_knock_maintenance_link": "https://www.park220apts.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "580-268-7092",
  "custom_ppc_tracking_phone_number": "580-751-2788"
};

export const generatedAt = '2026-10-07T17:11:34.294Z';
